export const plusIconResize = (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M12 20V12M12 12V4M12 12H20M12 12H4"
            stroke="#545454"
            strokeWidth="2"
            strokeLinecap="round"
        />
    </svg>
);
export const plusIcon = (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M12 20V12M12 12V4M12 12H20M12 12H4"
            stroke="#545454"
            strokeWidth="2"
            strokeLinecap="round"
        />
    </svg>
);

export const updateIcon = (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M1.90296 7.29698C1.90296 10.341 4.10996 12.415 6.58896 12.844C6.6564 12.8557 6.72087 12.8805 6.7787 12.9171C6.83652 12.9537 6.88658 13.0014 6.92599 13.0573C6.96541 13.1133 6.99343 13.1764 7.00843 13.2432C7.02344 13.31 7.02515 13.379 7.01346 13.4465C7.00177 13.5139 6.97692 13.5784 6.94032 13.6362C6.90371 13.694 6.85608 13.7441 6.80013 13.7835C6.74418 13.8229 6.68102 13.8509 6.61424 13.866C6.54747 13.881 6.4784 13.8827 6.41096 13.871C3.49996 13.367 0.860962 10.913 0.860962 7.29698C0.860962 5.75998 1.55996 4.55198 2.37596 3.63398C2.96096 2.97598 3.62996 2.44098 4.16796 2.03198H2.53196C2.39935 2.03198 2.27218 1.9793 2.17841 1.88554C2.08464 1.79177 2.03196 1.66459 2.03196 1.53198C2.03196 1.39937 2.08464 1.2722 2.17841 1.17843C2.27218 1.08466 2.39935 1.03198 2.53196 1.03198H5.53196C5.66457 1.03198 5.79175 1.08466 5.88552 1.17843C5.97928 1.2722 6.03196 1.39937 6.03196 1.53198V4.53198C6.03196 4.66459 5.97928 4.79177 5.88552 4.88554C5.79175 4.9793 5.66457 5.03198 5.53196 5.03198C5.39935 5.03198 5.27218 4.9793 5.17841 4.88554C5.08464 4.79177 5.03196 4.66459 5.03196 4.53198V2.68598L5.03096 2.68798C4.45896 3.11798 3.76096 3.64498 3.15596 4.32598C2.44096 5.12998 1.90296 6.10198 1.90296 7.29598V7.29698ZM13.011 7.70298C13.011 4.69098 10.851 2.62998 8.40396 2.16998C8.33576 2.15841 8.27055 2.13337 8.21212 2.09633C8.1537 2.05929 8.10324 2.01098 8.06369 1.95423C8.02413 1.89748 7.99628 1.83341 7.98174 1.76578C7.96721 1.69815 7.96629 1.6283 7.97904 1.56031C7.99179 1.49232 8.01795 1.42755 8.056 1.36977C8.09404 1.312 8.14321 1.26238 8.20064 1.22381C8.25807 1.18525 8.3226 1.1585 8.39047 1.14514C8.45835 1.13177 8.5282 1.13206 8.59596 1.14598C11.47 1.68598 14.053 4.12598 14.053 7.70298C14.053 9.23998 13.354 10.447 12.538 11.366C11.953 12.024 11.284 12.559 10.746 12.968H12.382C12.5146 12.968 12.6417 13.0207 12.7355 13.1144C12.8293 13.2082 12.882 13.3354 12.882 13.468C12.882 13.6006 12.8293 13.7278 12.7355 13.8215C12.6417 13.9153 12.5146 13.968 12.382 13.968H9.38196C9.24935 13.968 9.12218 13.9153 9.02841 13.8215C8.93464 13.7278 8.88196 13.6006 8.88196 13.468V10.468C8.88196 10.3354 8.93464 10.2082 9.02841 10.1144C9.12218 10.0207 9.24935 9.96798 9.38196 9.96798C9.51457 9.96798 9.64175 10.0207 9.73552 10.1144C9.82928 10.2082 9.88196 10.3354 9.88196 10.468V12.313H9.88396C10.455 11.881 11.154 11.355 11.758 10.673C12.473 9.86998 13.011 8.89798 13.011 7.70298Z"
            fill="#545454"
        />
    </svg>
);

export const thumbsUpIcon = (
    <svg
        width="100"
        height="100"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
            d="M6.956 1.74498C7.021 0.809979 7.908 0.0869792 8.864 0.324979L9.125 0.390979C9.588 0.506979 9.999 0.846979 10.137 1.35598C10.357 2.17198 10.67 3.86698 10.199 5.86598C10.3463 5.84564 10.494 5.82863 10.642 5.81498C11.355 5.74998 12.311 5.74298 13.158 6.02498C13.676 6.19798 14.152 6.70598 14.358 7.29798C14.542 7.82998 14.518 8.45998 14.124 9.03098C14.182 9.14998 14.227 9.27298 14.262 9.39398C14.339 9.66398 14.375 9.96098 14.375 10.25C14.375 10.539 14.339 10.836 14.262 11.106C14.223 11.241 14.172 11.379 14.102 11.51C14.271 11.897 14.209 12.329 14.099 12.658C13.9864 12.9828 13.8216 13.2872 13.611 13.559C13.665 13.711 13.687 13.871 13.687 14.024C13.687 14.329 13.598 14.649 13.434 14.936C13.1 15.522 12.437 16 11.5 16H8C7.395 16 6.93 15.919 6.534 15.782C6.1935 15.6576 5.8681 15.4953 5.564 15.298L5.516 15.268C5.012 14.961 4.517 14.659 3.448 14.546C2.682 14.464 2 13.846 2 13V8.99998C2 8.14998 2.685 7.56798 3.357 7.38498C4.206 7.15298 4.931 6.59798 5.489 5.97498C6.049 5.34798 6.403 4.69498 6.528 4.33598C6.727 3.76098 6.884 2.79698 6.956 1.74598V1.74498Z"
            fill="white"
        />
    </svg>
);

// export const searchIcon = (
//     <svg width="24" height="24" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
//         <path
//             d="M1.83301 9.16651L9.85439 2.7494C10.5239 2.21374 11.4754 2.21374 12.145 2.7494L20.1663 9.16651"
//             stroke="#62638A"
//             strokeWidth="1.5"
//             strokeLinecap="round"
//             strokeLinejoin="round"
//         />
//         <path
//             d="M8.68815 3.71209L5.02149 6.69125C4.35576 7.23216 4.02289 7.50261 3.84494 7.87648C3.66699 8.25034 3.66699 8.67923 3.66699 9.53702V12.8334C3.66699 16.2904 3.66699 18.0189 4.74093 19.0928C5.81488 20.1668 7.54336 20.1668 11.0003 20.1668C14.4573 20.1668 16.1858 20.1668 17.2597 19.0928C18.3337 18.0189 18.3337 16.2904 18.3337 12.8334V9.53702C18.3337 8.67923 18.3337 8.25034 18.1557 7.87648C17.9777 7.50261 17.6449 7.23216 16.9792 6.69125L13.3125 3.71209C12.205 2.81223 11.6512 2.3623 11.0003 2.3623C10.3494 2.3623 9.79564 2.81223 8.68815 3.71209Z"
//             stroke="#62638A"
//             strokeWidth="1.5"
//         />
//         <path
//             d="M8.9375 14.8955H13.0625"
//             stroke="#62638A"
//             strokeWidth="1.5"
//             strokeLinecap="round"
//         />
//     </svg>
// );

// export const star = (
//     <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
//         <path
//             d="M10.19 3.35778C10.5347 2.70886 11.4646 2.70886 11.8092 3.35778L13.6022 6.73373C13.7347 6.9832 13.9749 7.15764 14.2531 7.20656L18.0178 7.86862C18.7415 7.99587 19.0288 8.88019 18.5181 9.40849L15.8615 12.157C15.6652 12.3601 15.5735 12.6424 15.6129 12.9221L16.1467 16.7072C16.2493 17.4347 15.497 17.9812 14.8368 17.6589L11.4019 15.9816C11.148 15.8576 10.8512 15.8576 10.5974 15.9816L7.16249 17.6589C6.50224 17.9812 5.74999 17.4347 5.85258 16.7072L6.38632 12.9221C6.42577 12.6424 6.33405 12.3601 6.13774 12.157L3.4811 9.40849C2.97045 8.88019 3.25779 7.99587 3.98145 7.86862L7.74624 7.20656C8.02443 7.15764 8.26455 6.98319 8.39704 6.73373L10.19 3.35778Z"
//             stroke="#62638A"
//             strokeWidth="1.5"
//         />
//     </svg>
// );

// export const download = (
//     <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
//         <path
//             d="M11 14.2083L13.75 11.4583M11 4.125V14.2083V4.125ZM11 14.2083L8.25 11.4583L11 14.2083Z"
//             stroke="#62638A"
//             strokeWidth="1.5"
//             strokeLinecap="round"
//             strokeLinejoin="round"
//         />
//         <path
//             d="M14.6663 17.417H7.33301C6.42887 17.417 6.1369 17.4127 5.91445 17.3775C4.54162 17.1601 3.46494 16.0833 3.24751 14.7105C3.21228 14.4881 3.20801 14.1961 3.20801 13.292C3.20801 12.3879 3.21228 12.0959 3.24751 11.8735C3.46494 10.5007 4.54162 9.42393 5.91445 9.2065C6.1369 9.1713 6.42887 9.16699 7.33301 9.16699H7.56217C7.94187 9.16699 8.24967 8.85918 8.24967 8.47949C8.24967 8.0998 7.94187 7.79199 7.56217 7.79199H7.33301C6.48142 7.79199 6.05562 7.79199 5.69935 7.84842C3.73818 8.15904 2.20006 9.69719 1.88944 11.6583C1.83301 12.0146 1.83301 12.4404 1.83301 13.292C1.83301 14.1436 1.83301 14.5694 1.88944 14.9257C2.20006 16.8868 3.73817 18.425 5.69935 18.7355C6.05562 18.792 6.48142 18.792 7.33301 18.792H14.6663C15.5179 18.792 15.9437 18.792 16.3 18.7355C18.2611 18.425 19.7993 16.8868 20.1099 14.9257C20.1663 14.5694 20.1663 14.1436 20.1663 13.292C20.1663 12.4404 20.1663 12.0146 20.1099 11.6583C19.7993 9.69719 18.2611 8.15904 16.3 7.84842C15.9437 7.79199 15.5179 7.79199 14.6663 7.79199H14.4372C14.0575 7.79199 13.7497 8.0998 13.7497 8.47949C13.7497 8.85918 14.0575 9.16699 14.4372 9.16699H14.6663C15.5704 9.16699 15.8624 9.1713 16.0849 9.2065C17.4577 9.42393 18.5344 10.5007 18.7518 11.8735C18.787 12.0959 18.7913 12.3879 18.7913 13.292C18.7913 14.1961 18.787 14.4881 18.7518 14.7105C18.5344 16.0833 17.4577 17.1601 16.0849 17.3775C15.8624 17.4127 15.5704 17.417 14.6663 17.417Z"
//             fill="#62638A"
//         />
//     </svg>
// );

// export const label = (
//     <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
//         <path
//             d="M8.25708 2.99299C9.89701 2.75415 10.5176 2.67743 11.0852 2.83282C11.1871 2.86072 11.2874 2.89402 11.3859 2.93257C11.9338 3.14736 12.3853 3.57982 13.5572 4.75167L14.7918 5.98634C15.8826 7.07709 16.6566 7.85271 17.1796 8.5177C17.6928 9.17044 17.9057 9.6461 17.9486 10.1219C17.9646 10.2997 17.9646 10.4785 17.9486 10.6564L18.6333 10.7181L17.9486 10.6564C17.9057 11.1321 17.6928 11.6078 17.1796 12.2604C16.6566 12.9255 15.8826 13.7011 14.7918 14.7918C13.7011 15.8826 12.9255 16.6566 12.2605 17.1795C11.6078 17.6928 11.1321 17.9057 10.6564 17.9485L10.7181 18.6333L10.6564 17.9485C10.4785 17.9646 10.2996 17.9646 10.1218 17.9485C9.64603 17.9057 9.17047 17.6928 8.51772 17.1795C7.85271 16.6566 7.07709 15.8826 5.98634 14.7918L4.75167 13.5572C3.57983 12.3853 3.14736 11.9337 2.93258 11.3858C2.89402 11.2875 2.86072 11.1871 2.83282 11.0852C2.67743 10.5176 2.75416 9.89699 2.99299 8.25708C3.16275 7.09149 3.28339 6.26906 3.44385 5.63455C3.60067 5.01444 3.78129 4.63717 4.03487 4.3434C4.13003 4.23315 4.23315 4.13003 4.34339 4.03487C4.63716 3.78129 5.01444 3.60067 5.63454 3.44385C6.26905 3.28339 7.09148 3.16275 8.25708 2.99299Z"
//             stroke="#62638A"
//             strokeWidth="1.5"
//         />
//         <path
//             d="M10.0837 10.0836C10.7587 9.40854 10.7587 8.31412 10.0837 7.6391C9.40865 6.96409 8.31423 6.96409 7.63922 7.6391C6.9642 8.31412 6.9642 9.40854 7.63922 10.0836C8.31423 10.7586 9.40865 10.7586 10.0837 10.0836Z"
//             stroke="#62638A"
//             strokeWidth="1.5"
//         />
//     </svg>
// );

// export const order = (
//     <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
//         <mask
//             id="mask0_594_840"
//             style={{ maskType: 'alpha' }}
//             maskUnits="userSpaceOnUse"
//             x="2"
//             y="1"
//             width="18"
//             height="20">
//             <path
//                 fillRule="evenodd"
//                 clipRule="evenodd"
//                 d="M3.82394 2.90695C2.75 3.9809 2.75 5.70937 2.75 9.16634V18.8839C2.75 20.2817 4.2517 21.1654 5.47368 20.4865L10.1096 17.911C10.6634 17.6033 11.3366 17.6033 11.8904 17.911L16.5263 20.4865C17.7483 21.1654 19.25 20.2817 19.25 18.8839V9.16634C19.25 5.70937 19.25 3.9809 18.176 2.90695C17.1022 1.83301 15.3736 1.83301 11.9167 1.83301H10.0833C6.62636 1.83301 4.89789 1.83301 3.82394 2.90695Z"
//                 fill="white"
//             />
//         </mask>
//         <g mask="url(#mask0_594_840)">
//             <path
//                 d="M18.176 2.90695L19.1483 1.93468L18.176 2.90695ZM10.1096 17.911L10.7774 19.1129L10.1096 17.911ZM11.8904 17.911L11.2226 19.1129L11.8904 17.911ZM5.47369 20.4865L6.14144 21.6885L5.47369 20.4865ZM4.125 9.16635C4.125 7.39899 4.12793 6.2118 4.24698 5.32623C4.36073 4.48022 4.5573 4.11814 4.79622 3.87922L2.85167 1.93468C2.01664 2.76971 1.67625 3.80884 1.52151 4.9598C1.37208 6.0712 1.375 7.47674 1.375 9.16635H4.125ZM4.125 18.8839V9.16635H1.375V18.8839H4.125ZM6.14144 21.6885L10.7774 19.1129L9.44195 16.709L4.80592 19.2845L6.14144 21.6885ZM11.2226 19.1129L15.8586 21.6885L17.1941 19.2845L12.5582 16.709L11.2226 19.1129ZM17.875 9.16635V18.8839H20.625V9.16635H17.875ZM17.2038 3.87922C17.4427 4.11814 17.6392 4.48022 17.753 5.32623C17.8721 6.2118 17.875 7.39899 17.875 9.16635H20.625C20.625 7.47674 20.6279 6.0712 20.4785 4.9598C20.3238 3.80884 19.9833 2.76971 19.1483 1.93468L17.2038 3.87922ZM11.9167 3.20801C13.684 3.20801 14.8712 3.21094 15.7568 3.32999C16.6028 3.44373 16.9648 3.64031 17.2038 3.87922L19.1483 1.93468C18.3133 1.09965 17.2741 0.759258 16.1233 0.604515C15.0118 0.455091 13.6063 0.458012 11.9167 0.458012V3.20801ZM10.0833 3.20801H11.9167V0.458012H10.0833V3.20801ZM4.79622 3.87922C5.03514 3.64031 5.39721 3.44373 6.24322 3.32999C7.12879 3.21094 8.31599 3.20801 10.0833 3.20801V0.458012C8.39373 0.458012 6.98819 0.455091 5.87679 0.604515C4.72583 0.759258 3.6867 1.09965 2.85167 1.93468L4.79622 3.87922ZM15.8586 21.6885C17.997 22.8766 20.625 21.3302 20.625 18.8839H17.875C17.875 19.2334 17.4995 19.4543 17.1941 19.2845L15.8586 21.6885ZM10.7774 19.1129C10.9159 19.036 11.0842 19.036 11.2226 19.1129L12.5582 16.709C11.5891 16.1707 10.4109 16.1707 9.44195 16.709L10.7774 19.1129ZM1.375 18.8839C1.375 21.3302 4.00299 22.8766 6.14144 21.6885L4.80592 19.2845C4.50043 19.4543 4.125 19.2334 4.125 18.8839H1.375Z"
//                 fill="#62638A"
//             />
//             <path
//                 d="M8.9375 9.39551H13.0625"
//                 stroke="#62638A"
//                 strokeWidth="1.5"
//                 strokeLinecap="round"
//             />
//         </g>
//     </svg>
// );

// export const wallet = (
//     <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
//         <path
//             d="M17.4167 8.9375H16.5C15.3609 8.9375 14.4375 9.86091 14.4375 11C14.4375 12.1391 15.3609 13.0625 16.5 13.0625H17.4167C18.5558 13.0625 19.4792 12.1391 19.4792 11C19.4792 9.86091 18.5558 8.9375 17.4167 8.9375Z"
//             stroke="#62638A"
//             strokeWidth="1.5"
//         />
//         <path
//             d="M9.16634 5.04199H11.9163C13.6837 5.04199 14.8708 5.04492 15.7564 5.16397C16.6024 5.27771 16.9645 5.47429 17.2035 5.7132C17.4424 5.95212 17.6389 6.3142 17.7527 7.16021C17.8249 7.69742 17.8544 8.34561 17.8664 9.16699H19.2417C19.2088 6.89405 19.0402 5.60543 18.1757 4.74093C17.1018 3.66699 15.3733 3.66699 11.9163 3.66699H9.16634C5.70937 3.66699 3.9809 3.66699 2.90695 4.74093C1.83301 5.81488 1.83301 7.54335 1.83301 11.0003C1.83301 14.4573 1.83301 16.1858 2.90695 17.2597C3.9809 18.3337 5.70937 18.3337 9.16634 18.3337H11.9163C15.3733 18.3337 17.1018 18.3337 18.1757 17.2597C19.0402 16.3952 19.2088 15.1066 19.2417 12.8337H17.8664C17.8544 13.655 17.8249 14.3033 17.7527 14.8404C17.6389 15.6864 17.4424 16.0485 17.2035 16.2875C16.9645 16.5264 16.6024 16.7229 15.7564 16.8366C14.8708 16.9557 13.6837 16.9587 11.9163 16.9587H9.16634C7.39899 16.9587 6.2118 16.9557 5.32622 16.8366C4.48021 16.7229 4.11814 16.5264 3.87922 16.2875C3.64031 16.0485 3.44373 15.6864 3.32999 14.8404C3.21093 13.9548 3.20801 12.7677 3.20801 11.0003C3.20801 9.23299 3.21093 8.04578 3.32999 7.16021C3.44373 6.3142 3.64031 5.95212 3.87922 5.7132C4.11814 5.47429 4.48021 5.27771 5.32622 5.16397C6.2118 5.04492 7.39899 5.04199 9.16634 5.04199Z"
//             fill="#62638A"
//         />
//         <path
//             d="M6.1875 8.47949H11.2292"
//             stroke="#62638A"
//             strokeWidth="1.5"
//             strokeLinecap="round"
//         />
//     </svg>
// );

// export const chat = (
//     <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
//         <path
//             fillRule="evenodd"
//             clipRule="evenodd"
//             d="M10.0833 3.4375C6.41295 3.4375 3.4375 6.41295 3.4375 10.0833C3.4375 11.6996 4.01362 13.1796 4.97243 14.3316C5.12231 14.5118 5.17016 14.7558 5.09936 14.9792L4.42246 17.1148L7.17569 16.2475C7.32636 16.2 7.48877 16.2058 7.63561 16.264C8.39221 16.564 9.21763 16.7292 10.0833 16.7292H11.9167C15.5871 16.7292 18.5625 13.7538 18.5625 10.0833C18.5625 6.41295 15.5871 3.4375 11.9167 3.4375H10.0833ZM2.0625 10.0833C2.0625 5.65355 5.65355 2.0625 10.0833 2.0625H11.9167C16.3465 2.0625 19.9375 5.65355 19.9375 10.0833C19.9375 14.5131 16.3465 18.1042 11.9167 18.1042H10.0833C9.12906 18.1042 8.21238 17.9372 7.36182 17.6304L4.41509 18.5587C3.53022 18.8375 2.69821 18.0041 2.97851 17.1197L3.42659 17.2618L2.97851 17.1197L3.67826 14.912C2.66426 13.5688 2.0625 11.8956 2.0625 10.0833Z"
//             fill="#62638A"
//         />
//         <path
//             d="M7.79167 11.0003C8.29793 11.0003 8.70833 10.5899 8.70833 10.0837C8.70833 9.5774 8.29793 9.16699 7.79167 9.16699C7.28541 9.16699 6.875 9.5774 6.875 10.0837C6.875 10.5899 7.28541 11.0003 7.79167 11.0003Z"
//             fill="#62638A"
//         />
//         <path
//             d="M10.9997 11.0003C11.5059 11.0003 11.9163 10.5899 11.9163 10.0837C11.9163 9.5774 11.5059 9.16699 10.9997 9.16699C10.4934 9.16699 10.083 9.5774 10.083 10.0837C10.083 10.5899 10.4934 11.0003 10.9997 11.0003Z"
//             fill="#62638A"
//         />
//         <path
//             d="M14.2087 11.0003C14.7149 11.0003 15.1253 10.5899 15.1253 10.0837C15.1253 9.5774 14.7149 9.16699 14.2087 9.16699C13.7024 9.16699 13.292 9.5774 13.292 10.0837C13.292 10.5899 13.7024 11.0003 14.2087 11.0003Z"
//             fill="#62638A"
//         />
//     </svg>
// );

// export const apps = (
//     <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
//         <path
//             d="M7.33301 2.52148H4.58301C3.44392 2.52148 2.52051 3.4449 2.52051 4.58398V7.33398C2.52051 8.47307 3.44392 9.39648 4.58301 9.39648H7.33301C8.4721 9.39648 9.39551 8.47307 9.39551 7.33398V4.58398C9.39551 3.4449 8.4721 2.52148 7.33301 2.52148Z"
//             stroke="#62638A"
//             strokeWidth="1.5"
//         />
//         <path
//             d="M17.417 2.52148H14.667C13.5279 2.52148 12.6045 3.4449 12.6045 4.58398V7.33398C12.6045 8.47307 13.5279 9.39648 14.667 9.39648H17.417C18.5561 9.39648 19.4795 8.47307 19.4795 7.33398V4.58398C19.4795 3.4449 18.5561 2.52148 17.417 2.52148Z"
//             stroke="#62638A"
//             strokeWidth="1.5"
//         />
//         <path
//             d="M17.417 12.6035H14.667C13.5279 12.6035 12.6045 13.5269 12.6045 14.666V17.416C12.6045 18.5551 13.5279 19.4785 14.667 19.4785H17.417C18.5561 19.4785 19.4795 18.5551 19.4795 17.416V14.666C19.4795 13.5269 18.5561 12.6035 17.417 12.6035Z"
//             stroke="#62638A"
//             strokeWidth="1.5"
//         />
//         <path
//             d="M7.33301 12.6035H4.58301C3.44392 12.6035 2.52051 13.5269 2.52051 14.666V17.416C2.52051 18.5551 3.44392 19.4785 4.58301 19.4785H7.33301C8.4721 19.4785 9.39551 18.5551 9.39551 17.416V14.666C9.39551 13.5269 8.4721 12.6035 7.33301 12.6035Z"
//             stroke="#62638A"
//             strokeWidth="1.5"
//         />
//     </svg>
// );

// export const settings = (
//     <svg width="22" height="24" viewBox="0 0 22 24" fill="none" xmlns="http://www.w3.org/2000/svg">
//         <path
//             d="M2.65888 7.7589L3.46555 6.23469C3.94222 5.33403 5.01116 5.01425 5.84471 5.53925C7.28159 6.44425 8.45571 5.70573 8.45289 3.89107C8.45258 2.85165 9.23497 1.9934 10.1956 1.99807L12.0228 2.0057C12.8653 1.99367 13.5468 2.74616 13.5578 3.66532L13.5581 3.88486C13.5529 5.69452 14.7278 6.43452 16.1698 5.52986L16.3442 5.42032C17.0794 4.97116 18.0175 5.23867 18.4292 6.0407L19.3488 7.76307C19.8329 8.6684 19.5428 9.83665 18.7174 10.3561C17.2754 11.2608 17.2762 12.7393 18.7131 13.6443C19.5388 14.1643 19.8319 15.3304 19.3507 16.2397L18.544 17.7639C18.0673 18.6646 16.9983 18.9844 16.1648 18.4594C14.7279 17.5544 13.5538 18.2929 13.5566 20.1075C13.5524 21.1556 12.7746 22.0052 11.8138 22.0006L9.98673 21.9929C9.14415 22.005 8.46275 21.2525 8.45172 20.3333L8.45147 20.1138C8.45659 18.3041 7.28168 17.5641 5.83969 18.4688L5.66528 18.5783C4.93009 19.0275 3.99202 18.76 3.58029 17.9579L2.66067 16.2356C2.17659 15.3302 2.46675 14.162 3.29205 13.6425C4.73404 12.7379 4.73325 11.2594 3.29638 10.3544C2.46283 9.82935 2.18222 8.65956 2.65888 7.7589Z"
//             stroke="#62638A"
//             strokeWidth="1.5"
//             strokeMiterlimit="10"
//             strokeLinecap="round"
//             strokeLinejoin="round"
//         />
//         <path
//             d="M13.9788 12C13.9788 10.2051 12.645 8.75 10.9997 8.75C9.35433 8.75 8.02051 10.2051 8.02051 12C8.02051 13.7949 9.35433 15.25 10.9997 15.25C12.645 15.25 13.9788 13.7949 13.9788 12Z"
//             stroke="#62638A"
//             strokeWidth="1.5"
//         />
//     </svg>
// );

// export const notification = (
//     <svg width="15" height="19" viewBox="0 0 15 19" fill="none" xmlns="http://www.w3.org/2000/svg">
//         <path
//             d="M0.0631032 11.1733V10.9944C0.0936546 10.4214 0.274479 9.86636 0.587631 9.38426C1.1098 8.7992 1.46877 8.08854 1.62886 7.32293C1.668 6.73953 1.62886 6.14058 1.668 5.5494C1.94984 2.71021 4.76036 0.75 7.45346 0.75H7.53174C10.2718 0.75 13.0119 2.71021 13.3094 5.5494C13.3642 6.1328 13.3094 6.73953 13.3563 7.32293C13.5125 8.08988 13.872 8.8015 14.3976 9.38426C14.7243 9.86087 14.9114 10.4183 14.9378 10.9944V11.1733C14.9426 11.9494 14.6645 12.701 14.1549 13.2891C13.5011 13.9865 12.6124 14.421 11.6575 14.5104C8.86899 14.8682 6.04575 14.8682 3.25724 14.5104C2.31342 14.4137 1.43707 13.9797 0.791178 13.2891C0.297557 12.6953 0.0387074 11.9431 0.0631032 11.1733Z"
//             fill="#1b3b5f"
//         />
//         <path
//             opacity="0.4"
//             d="M8.51819 15.7087C7.96235 15.6698 7.50828 15.7087 7.05421 15.7087C6.60389 15.7009 6.15431 15.7479 5.71549 15.8487C5.33971 15.9343 4.93262 16.1365 4.93262 16.5643C4.97205 16.9778 5.1962 17.3519 5.54326 17.5833C6.21181 18.0939 7.05429 18.3255 7.89189 18.229C8.70606 18.1689 9.45023 17.7493 9.91954 17.0855C10.1789 16.7492 10.1198 16.2685 9.78645 16.0043C9.39177 15.8114 8.95805 15.7103 8.51819 15.7087Z"
//             fill="#1b3b5f"
//         />
//     </svg>
// );

// export const arrowRight = (
//     <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
//         <g opacity="0.5">
//             <path
//                 d="M6.375 2.83398L11.6875 8.14648L6.375 13.459"
//                 stroke="#1B1B1B"
//                 strokeLinecap="round"
//                 strokeLinejoin="round"
//             />
//         </g>
//     </svg>
// );

// export const logout = (
//     <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
//         <g opacity="0.5">
//             <path
//                 d="M12 2.5L15 5.5M12 13.5V2.5V13.5ZM12 2.5L9 5.5L12 2.5Z"
//                 stroke="#1B1B1B"
//                 strokeLinecap="round"
//                 strokeLinejoin="round"
//             />
//             <path
//                 d="M16 18H8C7.01367 18 6.69515 17.9953 6.45248 17.9569C4.95485 17.7197 3.78029 16.5451 3.54309 15.0475C3.50466 14.8048 3.5 14.4863 3.5 13.5C3.5 12.5137 3.50466 12.1952 3.54309 11.9525C3.78029 10.4549 4.95485 9.2803 6.45248 9.0431C6.69515 9.0047 7.01367 9 8 9H8.25C8.66421 9 9 8.66421 9 8.25C9 7.83579 8.66421 7.5 8.25 7.5H8C7.07099 7.5 6.60649 7.5 6.21783 7.56156C4.07837 7.90042 2.40042 9.5784 2.06156 11.7178C2 12.1065 2 12.571 2 13.5C2 14.429 2 14.8935 2.06156 15.2822C2.40042 17.4216 4.07836 19.0996 6.21783 19.4384C6.60649 19.5 7.07099 19.5 8 19.5H16C16.929 19.5 17.3935 19.5 17.7822 19.4384C19.9216 19.0996 21.5996 17.4216 21.9384 15.2822C22 14.8935 22 14.429 22 13.5C22 12.571 22 12.1065 21.9384 11.7178C21.5996 9.5784 19.9216 7.90042 17.7822 7.56156C17.3935 7.5 16.929 7.5 16 7.5H15.75C15.3358 7.5 15 7.83579 15 8.25C15 8.66421 15.3358 9 15.75 9H16C16.9863 9 17.3048 9.0047 17.5475 9.0431C19.0451 9.2803 20.2197 10.4549 20.4569 11.9525C20.4953 12.1952 20.5 12.5137 20.5 13.5C20.5 14.4863 20.4953 14.8048 20.4569 15.0475C20.2197 16.5451 19.0451 17.7197 17.5475 17.9569C17.3048 17.9953 16.9863 18 16 18Z"
//                 fill="#1B1B1B"
//             />
//         </g>
//     </svg>
// );

// export const backbtn = (
//     <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
//         <path
//             d="M15 18L9 12L15 6"
//             stroke="#090A0A"
//             strokeWidth="1.5"
//             strokeLinecap="round"
//             strokeLinejoin="round"
//         />
//     </svg>
// );
// export const delivery = (
//     <svg width="27" height="24" viewBox="0 0 27 24" fill="none" xmlns="http://www.w3.org/2000/svg">
//         <path
//             d="M20.1103 14.4658C18.2595 14.4658 16.7539 15.8042 16.7539 17.4493C16.7539 19.0944 18.2595 20.4327 20.1103 20.4327C21.9614 20.4327 23.4667 19.0944 23.4667 17.4493C23.4667 15.8042 21.961 14.4658 20.1103 14.4658ZM20.1103 18.941C19.1848 18.941 18.4321 18.272 18.4321 17.4493C18.4321 16.6266 19.1848 15.9575 20.1103 15.9575C21.0358 15.9575 21.7885 16.6266 21.7885 17.4493C21.7885 18.272 21.0358 18.941 20.1103 18.941Z"
//             fill="black"
//         />
//         <path
//             d="M8.64271 14.4658C6.79195 14.4658 5.28632 15.8042 5.28632 17.4493C5.28632 19.0944 6.79195 20.4327 8.64271 20.4327C10.4935 20.4327 11.9991 19.0944 11.9991 17.4493C11.9991 15.8042 10.4935 14.4658 8.64271 14.4658ZM8.64271 18.941C7.7172 18.941 6.96451 18.272 6.96451 17.4493C6.96451 16.6266 7.7172 15.9575 8.64271 15.9575C9.56795 15.9575 10.3209 16.6266 10.3209 17.4493C10.3209 18.272 9.56821 18.941 8.64271 18.941Z"
//             fill="black"
//         />
//         <path
//             d="M22.3705 5.92636C22.2279 5.67451 21.9378 5.51562 21.6207 5.51562H17.2014V7.00735H21.1032L23.388 11.0469L24.8878 10.3766L22.3705 5.92636Z"
//             fill="black"
//         />
//         <path d="M17.593 16.7285H11.2439V18.2202H17.593V16.7285Z" fill="black" />
//         <path
//             d="M6.1254 16.7285H3.21657C2.75309 16.7285 2.3775 17.0624 2.3775 17.4744C2.3775 17.8863 2.75314 18.2202 3.21657 18.2202H6.12545C6.58893 18.2202 6.96452 17.8863 6.96452 17.4744C6.96452 17.0624 6.58888 16.7285 6.1254 16.7285Z"
//             fill="black"
//         />
//         <path
//             d="M26.4511 12.1687L24.8006 10.2792C24.6421 10.0972 24.3973 9.9908 24.138 9.9908H18.0406V4.76977C18.0406 4.35778 17.6649 4.02393 17.2015 4.02393H3.21657C2.75309 4.02393 2.3775 4.35783 2.3775 4.76977C2.3775 5.1817 2.75314 5.51561 3.21657 5.51561H16.3624V10.7366C16.3624 11.1486 16.738 11.4825 17.2015 11.4825H23.7271L24.9491 12.8817V16.7284H22.6276C22.1641 16.7284 21.7885 17.0623 21.7885 17.4742C21.7885 17.8862 22.1642 18.2201 22.6276 18.2201H25.7882C26.2517 18.2201 26.6273 17.8862 26.6273 17.4742V12.6262C26.6273 12.4606 26.5652 12.2995 26.4511 12.1687Z"
//             fill="black"
//         />
//         <path
//             d="M6.06948 12.9492H2.20962C1.74613 12.9492 1.37054 13.2831 1.37054 13.6951C1.37054 14.107 1.74619 14.4409 2.20962 14.4409H6.06943C6.53291 14.4409 6.9085 14.107 6.9085 13.6951C6.9085 13.2831 6.53291 12.9492 6.06948 12.9492Z"
//             fill="black"
//         />
//         <path
//             d="M7.99937 10.0156H0.839072C0.375642 10.0156 0 10.3495 0 10.7615C0 11.1735 0.375642 11.5074 0.839072 11.5074H7.99937C8.46285 11.5074 8.83844 11.1735 8.83844 10.7615C8.83844 10.3496 8.46285 10.0156 7.99937 10.0156Z"
//             fill="black"
//         />
//         <path
//             d="M9.36991 7.08203H2.20962C1.74613 7.08203 1.37054 7.41594 1.37054 7.82787C1.37054 8.23986 1.74619 8.57371 2.20962 8.57371H9.36991C9.83339 8.57371 10.209 8.23981 10.209 7.82787C10.209 7.41594 9.83339 7.08203 9.36991 7.08203Z"
//             fill="black"
//         />
//     </svg>
// );
// export const location = (
//     <svg width="20" height="24" viewBox="0 0 20 24" fill="none" xmlns="http://www.w3.org/2000/svg">
//         <path
//             d="M19 10C19 17 10 23 10 23C10 23 1 17 1 10C1 7.61305 1.94821 5.32387 3.63604 3.63604C5.32387 1.94821 7.61305 1 10 1C12.3869 1 14.6761 1.94821 16.364 3.63604C18.0518 5.32387 19 7.61305 19 10Z"
//             stroke="#090A0A"
//             strokeWidth="1.5"
//             strokeLinecap="round"
//             strokeLinejoin="round"
//         />
//         <path
//             d="M10 13C11.6569 13 13 11.6569 13 10C13 8.34315 11.6569 7 10 7C8.34315 7 7 8.34315 7 10C7 11.6569 8.34315 13 10 13Z"
//             stroke="#090A0A"
//             strokeWidth="1.5"
//             strokeLinecap="round"
//             strokeLinejoin="round"
//         />
//     </svg>
// );
// export const downloadBtn = (
//     <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
//         <path
//             d="M4 12V20C4 20.5304 4.21071 21.0391 4.58579 21.4142C4.96086 21.7893 5.46957 22 6 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V12M16 6L12 2M12 2L8 6M12 2L12 15"
//             stroke="white"
//             strokeWidth="1.5"
//             strokeLinecap="round"
//             strokeLinejoin="round"
//         />
//     </svg>
// );
// export const send = (
//     <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
//         <path
//             d="M22 2L11 13M22 2L15 22L11 13M22 2L2 9L11 13"
//             stroke="#404446"
//             strokeWidth="1.5"
//             strokeLinecap="round"
//             strokeLinejoin="round"
//         />
//     </svg>
// );
// export const blackHome = (
//     <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
//         <path
//             d="M2.75 8.24992L11 1.83325L19.25 8.24992V18.3333C19.25 18.8195 19.0568 19.2858 18.713 19.6296C18.3692 19.9734 17.9029 20.1666 17.4167 20.1666H4.58333C4.0971 20.1666 3.63079 19.9734 3.28697 19.6296C2.94315 19.2858 2.75 18.8195 2.75 18.3333V8.24992Z"
//             stroke="#090A0A"
//             strokeWidth="1.5"
//             strokeLinecap="round"
//             strokeLinejoin="round"
//         />
//     </svg>
// );
// export const stepper = (
//     <svg width="40" height="8" viewBox="0 0 40 8" fill="none" xmlns="http://www.w3.org/2000/svg">
//         <path
//             d="M0 4C0 1.79086 1.79086 0 4 0C6.20914 0 8 1.79086 8 4C8 6.20914 6.20914 8 4 8C1.79086 8 0 6.20914 0 4Z"
//             fill="#E3E5E6"
//         />
//         <path
//             d="M16 4C16 1.79086 17.7909 0 20 0C22.2091 0 24 1.79086 24 4C24 6.20914 22.2091 8 20 8C17.7909 8 16 6.20914 16 4Z"
//             fill="#1b3b5f"
//         />
//         <path
//             d="M32 4C32 1.79086 33.7909 0 36 0C38.2091 0 40 1.79086 40 4C40 6.20914 38.2091 8 36 8C33.7909 8 32 6.20914 32 4Z"
//             fill="#E3E5E6"
//         />
//     </svg>
// );
// export const hamburger = (
//     <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
//         <path d="M4 9.33325H28" stroke="#181717" strokeWidth="1.5" strokeLinecap="round" />
//         <path d="M4 16H25.3333" stroke="#181717" strokeWidth="1.5" strokeLinecap="round" />
//         <path d="M4 22.6667H22.6667" stroke="#181717" strokeWidth="1.5" strokeLinecap="round" />
//     </svg>
// );
// export const openMenu = (
//     <svg width="57" height="57" viewBox="0 0 57 57" fill="none" xmlns="http://www.w3.org/2000/svg">
//         <circle cx="28.5" cy="28.5" r="28.5" fill="#1b3b5f" />
//         <path
//             d="M28.5544 39.4561C29.3315 39.4561 29.9728 38.8202 29.9728 38.0431V28.5543C29.9728 28.5434 29.9728 28.5271 29.9728 28.5163C29.9728 28.5054 29.9728 28.4945 29.9728 28.4782C29.9673 28.4673 29.9673 28.4565 29.9673 28.4402C29.9673 28.4293 29.9619 28.4184 29.9619 28.4021C29.9565 28.3913 29.9565 28.3804 29.9565 28.3641C29.951 28.3532 29.951 28.3423 29.951 28.326C29.9456 28.3152 29.9456 28.3043 29.9456 28.2934C29.9456 28.2826 29.9402 28.2663 29.9402 28.2554C29.9347 28.2445 29.9347 28.2337 29.9347 28.2228C29.9293 28.2119 29.9293 28.2011 29.9239 28.1902C29.7663 27.5761 29.2119 27.125 28.5544 27.125H18.9569C18.1797 27.125 17.5385 27.7608 17.5385 28.5434C17.5385 29.3206 18.1743 29.9564 18.9569 29.9564H25.1034L20.7883 34.2715C20.2394 34.8204 20.2394 35.7225 20.7883 36.2714C21.3372 36.8203 22.2394 36.8203 22.7937 36.2714L27.1359 31.9292V38.0322C27.1359 38.8148 27.7718 39.4561 28.5544 39.4561Z"
//             fill="white"
//         />
//         <path
//             d="M20.7177 20.7883C20.1688 21.3372 20.1688 22.2393 20.7177 22.7937L23.6143 25.6903C24.1632 26.2392 25.0653 26.2392 25.6196 25.6903C26.174 25.1414 26.174 24.2338 25.6196 23.6849L22.723 20.7883C22.1687 20.234 21.2665 20.234 20.7177 20.7883Z"
//             fill="white"
//         />
//         <path
//             d="M28.4511 17.5383C27.6739 17.5383 27.0326 18.1742 27.0326 18.9513V23.049C27.0326 23.8316 27.6685 24.462 28.4511 24.462C29.2336 24.462 29.8695 23.8261 29.8695 23.049V18.9513C29.8695 18.1796 29.2336 17.5383 28.4511 17.5383Z"
//             fill="white"
//         />
//         <path
//             d="M36.2171 20.7122C35.6682 20.1633 34.7606 20.1633 34.2117 20.7122L31.3151 23.6088C30.7662 24.1577 30.7662 25.0599 31.3151 25.6088C31.864 26.1631 32.7715 26.1631 33.3204 25.6088L36.2171 22.7121C36.766 22.1632 36.766 21.2665 36.2171 20.7122Z"
//             fill="white"
//         />
//         <path
//             d="M39.4615 28.4457C39.4615 27.6686 38.8257 27.0327 38.0431 27.0327H33.9454C33.1628 27.0327 32.5324 27.6686 32.5324 28.4457C32.5324 29.2283 33.1683 29.8641 33.9454 29.8641H38.0431C38.8257 29.8641 39.4615 29.2283 39.4615 28.4457Z"
//             fill="white"
//         />
//         <path
//             d="M36.2877 36.206C36.8366 35.6571 36.8366 34.7495 36.2877 34.2006L33.3911 31.304C32.8422 30.7551 31.9401 30.7551 31.3857 31.304C30.8369 31.8529 30.8369 32.7605 31.3857 33.3094L34.2824 36.206C34.8367 36.7603 35.7388 36.7603 36.2877 36.206Z"
//             fill="white"
//         />
//     </svg>
// );
// export const tag = (
//     <svg width="38" height="38" viewBox="0 0 38 38" fill="none" xmlns="http://www.w3.org/2000/svg">
//         <path
//             d="M11.0833 11.0833H11.0992M32.6008 21.2325L21.2483 32.585C20.9542 32.8794 20.605 33.113 20.2206 33.2723C19.8361 33.4317 19.4241 33.5137 19.0079 33.5137C18.5918 33.5137 18.1797 33.4317 17.7953 33.2723C17.4109 33.113 17.0616 32.8794 16.7675 32.585L3.16667 19V3.16663H19L32.6008 16.7675C33.1906 17.3608 33.5217 18.1634 33.5217 19C33.5217 19.8365 33.1906 20.6391 32.6008 21.2325Z"
//             stroke="#090A0A"
//             strokeWidth="1.5"
//             strokeLinecap="round"
//             strokeLinejoin="round"
//         />
//     </svg>
// );
// export const videoLogo = (
//     <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
//         <path
//             d="M26.8333 8.16659L18.6667 13.9999L26.8333 19.8333V8.16659Z"
//             stroke="white"
//             strokeLinecap="round"
//             strokeLinejoin="round"
//         />
//         <path
//             d="M16.3333 5.83325H3.5C2.21133 5.83325 1.16666 6.87792 1.16666 8.16659V19.8333C1.16666 21.1219 2.21133 22.1666 3.5 22.1666H16.3333C17.622 22.1666 18.6667 21.1219 18.6667 19.8333V8.16659C18.6667 6.87792 17.622 5.83325 16.3333 5.83325Z"
//             stroke="white"
//             strokeLinecap="round"
//             strokeLinejoin="round"
//         />
//     </svg>
// );
// export const heart = (
//     <svg width="20" height="19" viewBox="0 0 20 19" fill="none" xmlns="http://www.w3.org/2000/svg">
//         <path
//             d="M17.612 2.50292C17.1722 2.02645 16.65 1.64848 16.0752 1.39061C15.5005 1.13273 14.8844 1 14.2623 1C13.6401 1 13.0241 1.13273 12.4493 1.39061C11.8746 1.64848 11.3524 2.02645 10.9126 2.50292L9.99977 3.4913L9.08699 2.50292C8.19858 1.54094 6.99364 1.0005 5.73725 1.0005C4.48085 1.0005 3.27591 1.54094 2.38751 2.50292C1.4991 3.46491 1 4.76964 1 6.1301C1 7.49055 1.4991 8.79528 2.38751 9.75727L3.30029 10.7457L9.99977 18L16.6992 10.7457L17.612 9.75727C18.0521 9.28102 18.4011 8.71557 18.6393 8.0932C18.8774 7.47084 19 6.80377 19 6.1301C19 5.45642 18.8774 4.78935 18.6393 4.16699C18.4011 3.54463 18.0521 2.97917 17.612 2.50292V2.50292Z"
//             stroke="#090A0A"
//             strokeLinecap="round"
//             strokeLinejoin="round"
//         />
//     </svg>
// );

// export const productImport = (
//     <svg width="19" height="17" viewBox="0 0 19 17" fill="none" xmlns="http://www.w3.org/2000/svg">
//         <path
//             d="M6.33334 12.4583L9.50001 15.6249M9.50001 15.6249L12.6667 12.4583M9.50001 15.6249V8.49995M16.53 13.3212C17.2183 12.8372 17.7344 12.1465 18.0035 11.3493C18.2726 10.5521 18.2807 9.68984 18.0266 8.88773C17.7724 8.08561 17.2693 7.38535 16.5902 6.88856C15.9111 6.39176 15.0914 6.12429 14.25 6.12495H13.2525C13.0144 5.19701 12.5689 4.33518 11.9495 3.60434C11.3301 2.8735 10.553 2.29269 9.67672 1.90564C8.80039 1.51859 7.84768 1.33539 6.8903 1.36981C5.93293 1.40424 4.99583 1.65541 4.14957 2.10441C3.30331 2.55341 2.56994 3.18854 2.00466 3.96198C1.43938 4.73542 1.05693 5.62702 0.886092 6.56967C0.715258 7.51231 0.760494 8.48142 1.01839 9.40405C1.2763 10.3267 1.74014 11.1788 2.37501 11.8962"
//             stroke="#090A0A"
//             strokeLinecap="round"
//             strokeLinejoin="round"
//         />
//     </svg>
// );

// export const userIcon = (
//     <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
//         <path
//             d="M20.25 21V19C20.25 17.9391 19.8286 16.9217 19.0784 16.1716C18.3283 15.4214 17.3109 15 16.25 15H8.25C7.18913 15 6.17172 15.4214 5.42157 16.1716C4.67143 16.9217 4.25 17.9391 4.25 19V21"
//             stroke="#979C9E"
//             strokeWidth="1.5"
//             strokeLinecap="round"
//             strokeLinejoin="round"
//         />
//         <path
//             d="M12.25 11C14.4591 11 16.25 9.20914 16.25 7C16.25 4.79086 14.4591 3 12.25 3C10.0409 3 8.25 4.79086 8.25 7C8.25 9.20914 10.0409 11 12.25 11Z"
//             stroke="#979C9E"
//             strokeWidth="1.5"
//             strokeLinecap="round"
//             strokeLinejoin="round"
//         />
//     </svg>
// );

// export const bellIcon = (
//     <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
//         <path
//             d="M14.23 21C14.0542 21.3031 13.8018 21.5547 13.4982 21.7295C13.1946 21.9044 12.8504 21.9965 12.5 21.9965C12.1496 21.9965 11.8054 21.9044 11.5018 21.7295C11.1982 21.5547 10.9458 21.3031 10.77 21M18.5 8C18.5 6.4087 17.8679 4.88258 16.7426 3.75736C15.6174 2.63214 14.0913 2 12.5 2C10.9087 2 9.38258 2.63214 8.25736 3.75736C7.13214 4.88258 6.5 6.4087 6.5 8C6.5 15 3.5 17 3.5 17H21.5C21.5 17 18.5 15 18.5 8Z"
//             stroke="#979C9E"
//             strokeWidth="1.5"
//             strokeLinecap="round"
//             strokeLinejoin="round"
//         />
//     </svg>
// );

// export const homeIcon = (
//     <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
//         <path
//             d="M3 9L12 2L21 9V20C21 20.5304 20.7893 21.0391 20.4142 21.4142C20.0391 21.7893 19.5304 22 19 22H5C4.46957 22 3.96086 21.7893 3.58579 21.4142C3.21071 21.0391 3 20.5304 3 20V9Z"
//             stroke="#979C9E"
//             strokeWidth="1.5"
//             strokeLinecap="round"
//             strokeLinejoin="round"
//         />
//     </svg>
// );

// export const heartNav = (
//     <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
//         <path
//             d="M21.59 4.61012C21.0793 4.09912 20.4728 3.69376 19.8054 3.4172C19.1379 3.14064 18.4225 2.99829 17.7 2.99829C16.9775 2.99829 16.2621 3.14064 15.5947 3.4172C14.9272 3.69376 14.3208 4.09912 13.81 4.61012L12.75 5.67012L11.69 4.61012C10.6583 3.57842 9.25907 2.99883 7.80003 2.99883C6.341 2.99883 4.94172 3.57842 3.91003 4.61012C2.87834 5.64181 2.29874 7.04108 2.29874 8.50012C2.29874 9.95915 2.87834 11.3584 3.91003 12.3901L4.97003 13.4501L12.75 21.2301L20.53 13.4501L21.59 12.3901C22.101 11.8794 22.5064 11.2729 22.7829 10.6055C23.0595 9.93801 23.2019 9.2226 23.2019 8.50012C23.2019 7.77763 23.0595 7.06222 22.7829 6.39476C22.5064 5.7273 22.101 5.12087 21.59 4.61012V4.61012Z"
//             stroke="#979C9E"
//             strokeWidth="1.5"
//             strokeLinecap="round"
//             strokeLinejoin="round"
//         />
//     </svg>
// );
// export const cartIcon = (
//     <svg width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg">
//         <path
//             d="M1.09806 0.0244802C0.827278 -0.0296758 0.563866 0.145933 0.50971 0.416712C0.455554 0.687492 0.631162 0.950905 0.901942 1.00506L1.09806 0.0244802ZM3.52 3.66477L3.02238 3.71453L3.02356 3.72434L3.52 3.66477ZM18.2855 6.5226L17.8005 6.40134L18.2855 6.5226ZM3.3972 2.4368L2.89968 2.48655L3.3972 2.4368ZM0.901942 1.00506L1.7013 1.16493L1.89742 0.184352L1.09806 0.0244802L0.901942 1.00506ZM6.37435 13.1648H14.0173V12.1648H6.37435V13.1648ZM17.8979 10.1349L18.7706 6.64387L17.8005 6.40134L16.9277 9.89238L17.8979 10.1349ZM2.89968 2.48655L3.02248 3.71452L4.01752 3.61502L3.89472 2.38704L2.89968 2.48655ZM3.02356 3.72434L3.89216 10.9626L4.88503 10.8435L4.01644 3.6052L3.02356 3.72434ZM16.0542 3.16477H3.52V4.16477H16.0542V3.16477ZM18.7706 6.64387C19.2124 4.87666 17.8758 3.16477 16.0542 3.16477V4.16477C17.2252 4.16477 18.0845 5.26527 17.8005 6.40134L18.7706 6.64387ZM14.0173 13.1648C15.8528 13.1648 17.4527 11.9156 17.8979 10.1349L16.9277 9.89238C16.5938 11.2279 15.3939 12.1648 14.0173 12.1648V13.1648ZM6.37435 12.1648C5.61505 12.1648 4.9755 11.5974 4.88503 10.8435L3.89216 10.9626C4.04294 12.2191 5.10885 13.1648 6.37435 13.1648V12.1648ZM1.7013 1.16493C2.3478 1.29423 2.83408 1.83052 2.89968 2.48655L3.89472 2.38704C3.78538 1.29366 2.97492 0.399852 1.89742 0.184352L1.7013 1.16493Z"
//             fill="#090A0A"
//         />
//         <path
//             d="M10.8999 9.96484H7.29993"
//             stroke="#090A0A"
//             strokeLinecap="round"
//             strokeLinejoin="round"
//         />
//         <circle cx="6.85" cy="15.8147" r="1.35" fill="#090A0A" />
//         <circle cx="14.95" cy="15.8147" r="1.35" fill="#090A0A" />
//     </svg>
// );
// export const whiteCart = (
//     <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
//         <g clipPath="url(#clip0_957_12585)">
//             <path
//                 d="M2.56248 6.39993L1.33876 1.60839H0V0.855225H1.92373L2.21221 1.98475L10 1.97918L9.17204 6.39989H2.56248V6.39993ZM2.40451 2.73778L3.14745 5.64675H8.54685L9.09257 2.73299L2.40451 2.73778Z"
//                 fill="white"
//             />
//             <path
//                 d="M3.59349 9.1447C2.92937 9.1447 2.38906 8.60438 2.38906 7.94026C2.38906 7.27613 2.92937 6.73584 3.59349 6.73584H8.1313C8.79543 6.73584 9.33574 7.27613 9.33574 7.94026C9.33574 8.60438 8.79544 9.1447 8.1313 9.1447C7.46717 9.1447 6.92688 8.60438 6.92688 7.94026C6.92688 7.78076 6.95812 7.62845 7.01467 7.489H4.71012C4.76668 7.62845 4.79793 7.78076 4.79793 7.94026C4.79792 8.60438 4.25761 9.1447 3.59349 9.1447ZM7.68004 7.94026C7.68004 8.1891 7.88247 8.39153 8.1313 8.39153C8.38014 8.39153 8.58258 8.1891 8.58258 7.94026C8.58258 7.69144 8.38015 7.489 8.1313 7.489C7.88247 7.489 7.68004 7.69144 7.68004 7.94026ZM3.14221 7.94026C3.14221 8.1891 3.34465 8.39153 3.59348 8.39153C3.84231 8.39153 4.04474 8.1891 4.04474 7.94026C4.04474 7.69144 3.84231 7.489 3.59348 7.489C3.34465 7.489 3.14221 7.69144 3.14221 7.94026Z"
//                 fill="white"
//             />
//         </g>
//         <defs>
//             <clipPath id="clip0_957_12585">
//                 <rect width="10" height="10" fill="white" transform="matrix(-1 0 0 1 10 0)" />
//             </clipPath>
//         </defs>
//     </svg>
// );
// export const blackheart = (
//     <svg width="12" height="10" viewBox="0 0 12 10" fill="none" xmlns="http://www.w3.org/2000/svg">
//         <path
//             d="M6.31 9.40505C6.14 9.46505 5.86 9.46505 5.69 9.40505C4.24 8.91005 1 6.84505 1 3.34505C1 1.80005 2.245 0.550049 3.78 0.550049C4.69 0.550049 5.495 0.990049 6 1.67005C6.505 0.990049 7.315 0.550049 8.22 0.550049C9.755 0.550049 11 1.80005 11 3.34505C11 6.84505 7.76 8.91005 6.31 9.40505Z"
//             stroke="#121212"
//             strokeLinecap="round"
//             strokeLinejoin="round"
//         />
//     </svg>
// );
// export const filter = (
//     <svg width="15" height="11" viewBox="0 0 15 11" fill="none" xmlns="http://www.w3.org/2000/svg">
//         <path
//             d="M15 10.5H5V8.83333H15V10.5ZM15 6.33333H0V4.66667H15V6.33333ZM15 2.16667H5V0.5H15V2.16667Z"
//             fill="black"
//         />
//     </svg>
// );
// export const whitecartIcon = (
//     <svg width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg">
//         <path
//             d="M1.09806 0.0244802C0.827278 -0.0296758 0.563866 0.145933 0.50971 0.416712C0.455554 0.687492 0.631162 0.950905 0.901942 1.00506L1.09806 0.0244802ZM3.52 3.66477L3.02238 3.71453L3.02356 3.72434L3.52 3.66477ZM18.2855 6.5226L17.8005 6.40134L18.2855 6.5226ZM3.3972 2.4368L2.89968 2.48655L3.3972 2.4368ZM0.901942 1.00506L1.7013 1.16493L1.89742 0.184352L1.09806 0.0244802L0.901942 1.00506ZM6.37435 13.1648H14.0173V12.1648H6.37435V13.1648ZM17.8979 10.1349L18.7706 6.64387L17.8005 6.40134L16.9277 9.89238L17.8979 10.1349ZM2.89968 2.48655L3.02248 3.71452L4.01752 3.61502L3.89472 2.38704L2.89968 2.48655ZM3.02356 3.72434L3.89216 10.9626L4.88503 10.8435L4.01644 3.6052L3.02356 3.72434ZM16.0542 3.16477H3.52V4.16477H16.0542V3.16477ZM18.7706 6.64387C19.2124 4.87666 17.8758 3.16477 16.0542 3.16477V4.16477C17.2252 4.16477 18.0845 5.26527 17.8005 6.40134L18.7706 6.64387ZM14.0173 13.1648C15.8528 13.1648 17.4527 11.9156 17.8979 10.1349L16.9277 9.89238C16.5938 11.2279 15.3939 12.1648 14.0173 12.1648V13.1648ZM6.37435 12.1648C5.61505 12.1648 4.9755 11.5974 4.88503 10.8435L3.89216 10.9626C4.04294 12.2191 5.10885 13.1648 6.37435 13.1648V12.1648ZM1.7013 1.16493C2.3478 1.29423 2.83408 1.83052 2.89968 2.48655L3.89472 2.38704C3.78538 1.29366 2.97492 0.399852 1.89742 0.184352L1.7013 1.16493Z"
//             fill="white"
//         />
//         <path
//             d="M10.8999 9.96484H7.29993"
//             stroke="white"
//             strokeLinecap="round"
//             strokeLinejoin="round"
//         />
//         <circle cx="6.85" cy="15.8147" r="1.35" fill="white" />
//         <circle cx="14.95" cy="15.8147" r="1.35" fill="white" />
//     </svg>
// );

// export const downArrow = (
//     <svg width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
//         <g opacity="0.3">
//             <path
//                 d="M11.6667 5.625L7.29175 10.3125L2.91675 5.625"
//                 stroke="#1B1B1B"
//                 strokeWidth="1.5"
//                 strokeLinecap="round"
//                 strokeLinejoin="round"
//             />
//         </g>
//     </svg>
// );
// export const actions = (
//     <svg width="17" height="3" viewBox="0 0 17 3" fill="none" xmlns="http://www.w3.org/2000/svg">
//         <path
//             d="M8.5625 0.875C8.87316 0.875 9.125 1.12684 9.125 1.4375C9.125 1.74816 8.87316 2 8.5625 2C8.25184 2 8 1.74816 8 1.4375C8 1.12684 8.25184 0.875 8.5625 0.875Z"
//             fill="#090A0A"
//         />
//         <path
//             d="M15.5625 0.875C15.8732 0.875 16.125 1.12684 16.125 1.4375C16.125 1.74816 15.8732 2 15.5625 2C15.2518 2 15 1.74816 15 1.4375C15 1.12684 15.2518 0.875 15.5625 0.875Z"
//             fill="#090A0A"
//         />
//         <path
//             d="M1.5625 0.875C1.87316 0.875 2.125 1.12684 2.125 1.4375C2.125 1.74816 1.87316 2 1.5625 2C1.25184 2 1 1.74816 1 1.4375C1 1.12684 1.25184 0.875 1.5625 0.875Z"
//             fill="#090A0A"
//         />
//         <path
//             d="M8.5625 0.875C8.87316 0.875 9.125 1.12684 9.125 1.4375C9.125 1.74816 8.87316 2 8.5625 2C8.25184 2 8 1.74816 8 1.4375C8 1.12684 8.25184 0.875 8.5625 0.875Z"
//             stroke="#090A0A"
//             strokeWidth="1.5"
//             strokeLinecap="round"
//             strokeLinejoin="round"
//         />
//         <path
//             d="M15.5625 0.875C15.8732 0.875 16.125 1.12684 16.125 1.4375C16.125 1.74816 15.8732 2 15.5625 2C15.2518 2 15 1.74816 15 1.4375C15 1.12684 15.2518 0.875 15.5625 0.875Z"
//             stroke="#090A0A"
//             strokeWidth="1.5"
//             strokeLinecap="round"
//             strokeLinejoin="round"
//         />
//         <path
//             d="M1.5625 0.875C1.87316 0.875 2.125 1.12684 2.125 1.4375C2.125 1.74816 1.87316 2 1.5625 2C1.25184 2 1 1.74816 1 1.4375C1 1.12684 1.25184 0.875 1.5625 0.875Z"
//             stroke="#090A0A"
//             strokeWidth="1.5"
//             strokeLinecap="round"
//             strokeLinejoin="round"
//         />
//     </svg>
// );

export const deleteIcon = (
    <svg width="16" height="18" viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M2.2549 5.45652C1.52676 4.48567 2.21949 3.10022 3.43305 3.10022H13.0546C14.2682 3.10022 14.9609 4.48567 14.2328 5.45652V5.45652C13.7017 6.16463 13.4146 7.02588 13.4146 7.91101V12.889C13.4146 15.0981 11.6238 16.889 9.41461 16.889H7.07306C4.86392 16.889 3.07306 15.0981 3.07306 12.889V7.91101C3.07306 7.02588 2.78598 6.16463 2.2549 5.45652V5.45652Z"
            stroke="#090A0A"
        />
        <path
            d="M9.96753 12.5798L9.96753 7.40906"
            stroke="#090A0A"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M6.52026 12.5798L6.52026 7.40906"
            stroke="#090A0A"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M11.691 3.10016L11.2851 1.88231C11.0128 1.06563 10.2485 0.514771 9.38768 0.514771H7.09995C6.23908 0.514771 5.47481 1.06563 5.20258 1.88232L4.79663 3.10016"
            stroke="#090A0A"
            strokeLinecap="round"
        />
    </svg>
);

export const search = (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M21 21L16.65 16.65M19 11C19 15.4183 15.4183 19 11 19C6.58172 19 3 15.4183 3 11C3 6.58172 6.58172 3 11 3C15.4183 3 19 6.58172 19 11Z"
            stroke="#090A0A"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export const listIcon = (
    <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M8.33333 6.25H21.875M8.33333 12.5H21.875M8.33333 18.75H21.875M3.125 6.25H3.13542M3.125 12.5H3.13542M3.125 18.75H3.13542"
            stroke="#090A0A"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);
export const lockIcon = (
    <svg width="20" height="22" viewBox="0 0 20 22" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M5 10V6C5 4.67392 5.52678 3.40215 6.46447 2.46447C7.40215 1.52678 8.67392 1 10 1C11.3261 1 12.5979 1.52678 13.5355 2.46447C14.4732 3.40215 15 4.67392 15 6V10M3 10H17C18.1046 10 19 10.8954 19 12V19C19 20.1046 18.1046 21 17 21H3C1.89543 21 1 20.1046 1 19V12C1 10.8954 1.89543 10 3 10Z"
            stroke="#090A0A"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export const cardIcon = (
    <svg width="24" height="18" viewBox="0 0 24 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M1 7H23M3 1H21C22.1046 1 23 1.89543 23 3V15C23 16.1046 22.1046 17 21 17H3C1.89543 17 1 16.1046 1 15V3C1 1.89543 1.89543 1 3 1Z"
            stroke="#090A0A"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);
export const earningIcon = (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_810_10916)">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M17.25 21C20.985 21 24 19.5 24 17.25V3C24 1.5 21 0 17.25 0C13.5 0 10.5 1.5 10.5 3V8.25C12.255 8.985 13.755 10.215 14.82 11.775C15.555 11.919 16.365 11.9985 17.25 11.9985C19.215 11.9985 20.85 11.607 22.02 10.9695C22.1861 10.8782 22.3478 10.7791 22.5045 10.6725V12.7425C22.5045 13.095 22.224 13.6425 21.3015 14.1465C20.4075 14.634 19.0365 14.9925 17.2515 14.9925C16.8945 14.9925 16.5545 14.979 16.2315 14.952C16.3515 15.447 16.4315 15.952 16.4715 16.467C16.7245 16.481 16.9845 16.488 17.2515 16.488C19.2165 16.488 20.8515 16.0965 22.0215 15.459C22.1876 15.3677 22.3493 15.2686 22.506 15.162V17.232C22.506 17.586 22.2825 18.111 21.3195 18.63C20.3715 19.14 18.9495 19.482 17.2545 19.482C16.9095 19.482 16.5755 19.468 16.2525 19.44C16.1372 19.9386 15.9822 20.4271 15.789 20.901C16.261 20.954 16.749 20.9805 17.253 20.9805L17.25 21ZM21.3 9.66C22.2225 9.156 22.503 8.6085 22.503 8.256V6.186C22.348 6.292 22.1865 6.391 22.0185 6.483C20.8515 7.1205 19.2135 7.512 17.2485 7.512C15.2835 7.512 13.6485 7.1205 12.4785 6.483C12.3124 6.39171 12.1507 6.2926 11.994 6.186V8.256C11.994 8.6085 12.2745 9.156 13.197 9.6585C14.091 10.146 15.462 10.5045 17.247 10.5045C19.032 10.5045 20.397 10.146 21.297 9.6585L21.3 9.66ZM12 3.75C12 3.318 12.1875 2.9025 12.537 2.649C12.7275 2.511 12.9345 2.373 13.098 2.298C13.5075 2.109 15.558 1.4985 17.253 1.4985C18.948 1.4985 20.418 1.839 21.408 2.298C21.594 2.3835 21.7995 2.517 21.981 2.649C22.3275 2.8995 22.506 3.312 22.506 3.7395V3.7485C22.506 4.101 22.2255 4.6485 21.303 5.1525C20.409 5.64 19.038 5.9985 17.253 5.9985C15.468 5.9985 14.103 5.6385 13.203 5.1525C12.2805 4.65 12 4.101 12 3.75Z"
                fill="black"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M13.5 17.25C13.5 20.985 10.485 24 6.75 24C3.015 24 0 20.985 0 17.25C0 13.515 3.015 10.5 6.75 10.5C10.485 10.5 13.5 13.515 13.5 17.25ZM12 17.25C12 20.145 9.645 22.5 6.75 22.5C3.855 22.5 1.5 20.145 1.5 17.25C1.5 14.355 3.855 12 6.75 12C9.645 12 12 14.355 12 17.25Z"
                fill="black"
            />
        </g>
        <defs>
            <clipPath id="clip0_810_10916">
                <rect width="24" height="24" fill="white" />
            </clipPath>
        </defs>
    </svg>
);
export const locationIcon = (
    <svg width="20" height="24" viewBox="0 0 20 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M19 10C19 17 10 23 10 23C10 23 1 17 1 10C1 7.61305 1.94821 5.32387 3.63604 3.63604C5.32387 1.94821 7.61305 1 10 1C12.3869 1 14.6761 1.94821 16.364 3.63604C18.0518 5.32387 19 7.61305 19 10Z"
            stroke="#090A0A"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M10 13C11.6569 13 13 11.6569 13 10C13 8.34315 11.6569 7 10 7C8.34315 7 7 8.34315 7 10C7 11.6569 8.34315 13 10 13Z"
            stroke="#090A0A"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);
export const helpIcon = (
    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M8.09 8C8.3251 7.33167 8.78915 6.76811 9.39995 6.40913C10.0108 6.05016 10.7289 5.91894 11.4272 6.03871C12.1255 6.15849 12.7588 6.52152 13.2151 7.06353C13.6713 7.60553 13.9211 8.29152 13.92 9C13.92 11 10.92 12 10.92 12M11 16H11.01M21 11C21 16.5228 16.5228 21 11 21C5.47715 21 1 16.5228 1 11C1 5.47715 5.47715 1 11 1C16.5228 1 21 5.47715 21 11Z"
            stroke="#090A0A"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);
export const blackUser = (
    <svg width="18" height="20" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M17 19V17C17 15.9391 16.5786 14.9217 15.8284 14.1716C15.0783 13.4214 14.0609 13 13 13H5C3.93913 13 2.92172 13.4214 2.17157 14.1716C1.42143 14.9217 1 15.9391 1 17V19"
            stroke="#090A0A"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M9 9C11.2091 9 13 7.20914 13 5C13 2.79086 11.2091 1 9 1C6.79086 1 5 2.79086 5 5C5 7.20914 6.79086 9 9 9Z"
            stroke="#090A0A"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);
export const blackBellIcon = (
    <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M14.23 21C14.0542 21.3031 13.8018 21.5547 13.4982 21.7295C13.1946 21.9044 12.8504 21.9965 12.5 21.9965C12.1496 21.9965 11.8054 21.9044 11.5018 21.7295C11.1982 21.5547 10.9458 21.3031 10.77 21M18.5 8C18.5 6.4087 17.8679 4.88258 16.7426 3.75736C15.6174 2.63214 14.0913 2 12.5 2C10.9087 2 9.38258 2.63214 8.25736 3.75736C7.13214 4.88258 6.5 6.4087 6.5 8C6.5 15 3.5 17 3.5 17H21.5C21.5 17 18.5 15 18.5 8Z"
            stroke="#090A0A"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);
export const blackStar = (
    <svg width="22" height="21" viewBox="0 0 22 21" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M11 1L14.09 7.26L21 8.27L16 13.14L17.18 20.02L11 16.77L4.82 20.02L6 13.14L1 8.27L7.91 7.26L11 1Z"
            stroke="#090A0A"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);
export const searchIcon = (
    <svg width="24" height="24" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M1.83301 9.16651L9.85439 2.7494C10.5239 2.21374 11.4754 2.21374 12.145 2.7494L20.1663 9.16651"
            stroke="#62638A"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M8.68815 3.71209L5.02149 6.69125C4.35576 7.23216 4.02289 7.50261 3.84494 7.87648C3.66699 8.25034 3.66699 8.67923 3.66699 9.53702V12.8334C3.66699 16.2904 3.66699 18.0189 4.74093 19.0928C5.81488 20.1668 7.54336 20.1668 11.0003 20.1668C14.4573 20.1668 16.1858 20.1668 17.2597 19.0928C18.3337 18.0189 18.3337 16.2904 18.3337 12.8334V9.53702C18.3337 8.67923 18.3337 8.25034 18.1557 7.87648C17.9777 7.50261 17.6449 7.23216 16.9792 6.69125L13.3125 3.71209C12.205 2.81223 11.6512 2.3623 11.0003 2.3623C10.3494 2.3623 9.79564 2.81223 8.68815 3.71209Z"
            stroke="#62638A"
            strokeWidth="1.5"
        />
        <path
            d="M8.9375 14.8955H13.0625"
            stroke="#62638A"
            strokeWidth="1.5"
            strokeLinecap="round"
        />
    </svg>
);

export const star = (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M10.19 3.35778C10.5347 2.70886 11.4646 2.70886 11.8092 3.35778L13.6022 6.73373C13.7347 6.9832 13.9749 7.15764 14.2531 7.20656L18.0178 7.86862C18.7415 7.99587 19.0288 8.88019 18.5181 9.40849L15.8615 12.157C15.6652 12.3601 15.5735 12.6424 15.6129 12.9221L16.1467 16.7072C16.2493 17.4347 15.497 17.9812 14.8368 17.6589L11.4019 15.9816C11.148 15.8576 10.8512 15.8576 10.5974 15.9816L7.16249 17.6589C6.50224 17.9812 5.74999 17.4347 5.85258 16.7072L6.38632 12.9221C6.42577 12.6424 6.33405 12.3601 6.13774 12.157L3.4811 9.40849C2.97045 8.88019 3.25779 7.99587 3.98145 7.86862L7.74624 7.20656C8.02443 7.15764 8.26455 6.98319 8.39704 6.73373L10.19 3.35778Z"
            stroke="#62638A"
            strokeWidth="1.5"
        />
    </svg>
);

export const download = (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M11 14.2083L13.75 11.4583M11 4.125V14.2083V4.125ZM11 14.2083L8.25 11.4583L11 14.2083Z"
            stroke="#62638A"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M14.6663 17.417H7.33301C6.42887 17.417 6.1369 17.4127 5.91445 17.3775C4.54162 17.1601 3.46494 16.0833 3.24751 14.7105C3.21228 14.4881 3.20801 14.1961 3.20801 13.292C3.20801 12.3879 3.21228 12.0959 3.24751 11.8735C3.46494 10.5007 4.54162 9.42393 5.91445 9.2065C6.1369 9.1713 6.42887 9.16699 7.33301 9.16699H7.56217C7.94187 9.16699 8.24967 8.85918 8.24967 8.47949C8.24967 8.0998 7.94187 7.79199 7.56217 7.79199H7.33301C6.48142 7.79199 6.05562 7.79199 5.69935 7.84842C3.73818 8.15904 2.20006 9.69719 1.88944 11.6583C1.83301 12.0146 1.83301 12.4404 1.83301 13.292C1.83301 14.1436 1.83301 14.5694 1.88944 14.9257C2.20006 16.8868 3.73817 18.425 5.69935 18.7355C6.05562 18.792 6.48142 18.792 7.33301 18.792H14.6663C15.5179 18.792 15.9437 18.792 16.3 18.7355C18.2611 18.425 19.7993 16.8868 20.1099 14.9257C20.1663 14.5694 20.1663 14.1436 20.1663 13.292C20.1663 12.4404 20.1663 12.0146 20.1099 11.6583C19.7993 9.69719 18.2611 8.15904 16.3 7.84842C15.9437 7.79199 15.5179 7.79199 14.6663 7.79199H14.4372C14.0575 7.79199 13.7497 8.0998 13.7497 8.47949C13.7497 8.85918 14.0575 9.16699 14.4372 9.16699H14.6663C15.5704 9.16699 15.8624 9.1713 16.0849 9.2065C17.4577 9.42393 18.5344 10.5007 18.7518 11.8735C18.787 12.0959 18.7913 12.3879 18.7913 13.292C18.7913 14.1961 18.787 14.4881 18.7518 14.7105C18.5344 16.0833 17.4577 17.1601 16.0849 17.3775C15.8624 17.4127 15.5704 17.417 14.6663 17.417Z"
            fill="#62638A"
        />
    </svg>
);

export const label = (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M8.25708 2.99299C9.89701 2.75415 10.5176 2.67743 11.0852 2.83282C11.1871 2.86072 11.2874 2.89402 11.3859 2.93257C11.9338 3.14736 12.3853 3.57982 13.5572 4.75167L14.7918 5.98634C15.8826 7.07709 16.6566 7.85271 17.1796 8.5177C17.6928 9.17044 17.9057 9.6461 17.9486 10.1219C17.9646 10.2997 17.9646 10.4785 17.9486 10.6564L18.6333 10.7181L17.9486 10.6564C17.9057 11.1321 17.6928 11.6078 17.1796 12.2604C16.6566 12.9255 15.8826 13.7011 14.7918 14.7918C13.7011 15.8826 12.9255 16.6566 12.2605 17.1795C11.6078 17.6928 11.1321 17.9057 10.6564 17.9485L10.7181 18.6333L10.6564 17.9485C10.4785 17.9646 10.2996 17.9646 10.1218 17.9485C9.64603 17.9057 9.17047 17.6928 8.51772 17.1795C7.85271 16.6566 7.07709 15.8826 5.98634 14.7918L4.75167 13.5572C3.57983 12.3853 3.14736 11.9337 2.93258 11.3858C2.89402 11.2875 2.86072 11.1871 2.83282 11.0852C2.67743 10.5176 2.75416 9.89699 2.99299 8.25708C3.16275 7.09149 3.28339 6.26906 3.44385 5.63455C3.60067 5.01444 3.78129 4.63717 4.03487 4.3434C4.13003 4.23315 4.23315 4.13003 4.34339 4.03487C4.63716 3.78129 5.01444 3.60067 5.63454 3.44385C6.26905 3.28339 7.09148 3.16275 8.25708 2.99299Z"
            stroke="#62638A"
            strokeWidth="1.5"
        />
        <path
            d="M10.0837 10.0836C10.7587 9.40854 10.7587 8.31412 10.0837 7.6391C9.40865 6.96409 8.31423 6.96409 7.63922 7.6391C6.9642 8.31412 6.9642 9.40854 7.63922 10.0836C8.31423 10.7586 9.40865 10.7586 10.0837 10.0836Z"
            stroke="#62638A"
            strokeWidth="1.5"
        />
    </svg>
);

export const order = (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <mask
            id="mask0_594_840"
            style={{ maskType: 'alpha' }}
            maskUnits="userSpaceOnUse"
            x="2"
            y="1"
            width="18"
            height="20">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M3.82394 2.90695C2.75 3.9809 2.75 5.70937 2.75 9.16634V18.8839C2.75 20.2817 4.2517 21.1654 5.47368 20.4865L10.1096 17.911C10.6634 17.6033 11.3366 17.6033 11.8904 17.911L16.5263 20.4865C17.7483 21.1654 19.25 20.2817 19.25 18.8839V9.16634C19.25 5.70937 19.25 3.9809 18.176 2.90695C17.1022 1.83301 15.3736 1.83301 11.9167 1.83301H10.0833C6.62636 1.83301 4.89789 1.83301 3.82394 2.90695Z"
                fill="white"
            />
        </mask>
        <g mask="url(#mask0_594_840)">
            <path
                d="M18.176 2.90695L19.1483 1.93468L18.176 2.90695ZM10.1096 17.911L10.7774 19.1129L10.1096 17.911ZM11.8904 17.911L11.2226 19.1129L11.8904 17.911ZM5.47369 20.4865L6.14144 21.6885L5.47369 20.4865ZM4.125 9.16635C4.125 7.39899 4.12793 6.2118 4.24698 5.32623C4.36073 4.48022 4.5573 4.11814 4.79622 3.87922L2.85167 1.93468C2.01664 2.76971 1.67625 3.80884 1.52151 4.9598C1.37208 6.0712 1.375 7.47674 1.375 9.16635H4.125ZM4.125 18.8839V9.16635H1.375V18.8839H4.125ZM6.14144 21.6885L10.7774 19.1129L9.44195 16.709L4.80592 19.2845L6.14144 21.6885ZM11.2226 19.1129L15.8586 21.6885L17.1941 19.2845L12.5582 16.709L11.2226 19.1129ZM17.875 9.16635V18.8839H20.625V9.16635H17.875ZM17.2038 3.87922C17.4427 4.11814 17.6392 4.48022 17.753 5.32623C17.8721 6.2118 17.875 7.39899 17.875 9.16635H20.625C20.625 7.47674 20.6279 6.0712 20.4785 4.9598C20.3238 3.80884 19.9833 2.76971 19.1483 1.93468L17.2038 3.87922ZM11.9167 3.20801C13.684 3.20801 14.8712 3.21094 15.7568 3.32999C16.6028 3.44373 16.9648 3.64031 17.2038 3.87922L19.1483 1.93468C18.3133 1.09965 17.2741 0.759258 16.1233 0.604515C15.0118 0.455091 13.6063 0.458012 11.9167 0.458012V3.20801ZM10.0833 3.20801H11.9167V0.458012H10.0833V3.20801ZM4.79622 3.87922C5.03514 3.64031 5.39721 3.44373 6.24322 3.32999C7.12879 3.21094 8.31599 3.20801 10.0833 3.20801V0.458012C8.39373 0.458012 6.98819 0.455091 5.87679 0.604515C4.72583 0.759258 3.6867 1.09965 2.85167 1.93468L4.79622 3.87922ZM15.8586 21.6885C17.997 22.8766 20.625 21.3302 20.625 18.8839H17.875C17.875 19.2334 17.4995 19.4543 17.1941 19.2845L15.8586 21.6885ZM10.7774 19.1129C10.9159 19.036 11.0842 19.036 11.2226 19.1129L12.5582 16.709C11.5891 16.1707 10.4109 16.1707 9.44195 16.709L10.7774 19.1129ZM1.375 18.8839C1.375 21.3302 4.00299 22.8766 6.14144 21.6885L4.80592 19.2845C4.50043 19.4543 4.125 19.2334 4.125 18.8839H1.375Z"
                fill="#62638A"
            />
            <path
                d="M8.9375 9.39551H13.0625"
                stroke="#62638A"
                strokeWidth="1.5"
                strokeLinecap="round"
            />
        </g>
    </svg>
);

export const wallet = (
    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M17.4167 8.9375H16.5C15.3609 8.9375 14.4375 9.86091 14.4375 11C14.4375 12.1391 15.3609 13.0625 16.5 13.0625H17.4167C18.5558 13.0625 19.4792 12.1391 19.4792 11C19.4792 9.86091 18.5558 8.9375 17.4167 8.9375Z"
            stroke="#62638A"
            strokeWidth="1.5"
        />
        <path
            d="M9.16634 5.04199H11.9163C13.6837 5.04199 14.8708 5.04492 15.7564 5.16397C16.6024 5.27771 16.9645 5.47429 17.2035 5.7132C17.4424 5.95212 17.6389 6.3142 17.7527 7.16021C17.8249 7.69742 17.8544 8.34561 17.8664 9.16699H19.2417C19.2088 6.89405 19.0402 5.60543 18.1757 4.74093C17.1018 3.66699 15.3733 3.66699 11.9163 3.66699H9.16634C5.70937 3.66699 3.9809 3.66699 2.90695 4.74093C1.83301 5.81488 1.83301 7.54335 1.83301 11.0003C1.83301 14.4573 1.83301 16.1858 2.90695 17.2597C3.9809 18.3337 5.70937 18.3337 9.16634 18.3337H11.9163C15.3733 18.3337 17.1018 18.3337 18.1757 17.2597C19.0402 16.3952 19.2088 15.1066 19.2417 12.8337H17.8664C17.8544 13.655 17.8249 14.3033 17.7527 14.8404C17.6389 15.6864 17.4424 16.0485 17.2035 16.2875C16.9645 16.5264 16.6024 16.7229 15.7564 16.8366C14.8708 16.9557 13.6837 16.9587 11.9163 16.9587H9.16634C7.39899 16.9587 6.2118 16.9557 5.32622 16.8366C4.48021 16.7229 4.11814 16.5264 3.87922 16.2875C3.64031 16.0485 3.44373 15.6864 3.32999 14.8404C3.21093 13.9548 3.20801 12.7677 3.20801 11.0003C3.20801 9.23299 3.21093 8.04578 3.32999 7.16021C3.44373 6.3142 3.64031 5.95212 3.87922 5.7132C4.11814 5.47429 4.48021 5.27771 5.32622 5.16397C6.2118 5.04492 7.39899 5.04199 9.16634 5.04199Z"
            fill="#62638A"
        />
        <path
            d="M6.1875 8.47949H11.2292"
            stroke="#62638A"
            strokeWidth="1.5"
            strokeLinecap="round"
        />
    </svg>
);

export const chat = (
    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10.0833 3.4375C6.41295 3.4375 3.4375 6.41295 3.4375 10.0833C3.4375 11.6996 4.01362 13.1796 4.97243 14.3316C5.12231 14.5118 5.17016 14.7558 5.09936 14.9792L4.42246 17.1148L7.17569 16.2475C7.32636 16.2 7.48877 16.2058 7.63561 16.264C8.39221 16.564 9.21763 16.7292 10.0833 16.7292H11.9167C15.5871 16.7292 18.5625 13.7538 18.5625 10.0833C18.5625 6.41295 15.5871 3.4375 11.9167 3.4375H10.0833ZM2.0625 10.0833C2.0625 5.65355 5.65355 2.0625 10.0833 2.0625H11.9167C16.3465 2.0625 19.9375 5.65355 19.9375 10.0833C19.9375 14.5131 16.3465 18.1042 11.9167 18.1042H10.0833C9.12906 18.1042 8.21238 17.9372 7.36182 17.6304L4.41509 18.5587C3.53022 18.8375 2.69821 18.0041 2.97851 17.1197L3.42659 17.2618L2.97851 17.1197L3.67826 14.912C2.66426 13.5688 2.0625 11.8956 2.0625 10.0833Z"
            fill="#62638A"
        />
        <path
            d="M7.79167 11.0003C8.29793 11.0003 8.70833 10.5899 8.70833 10.0837C8.70833 9.5774 8.29793 9.16699 7.79167 9.16699C7.28541 9.16699 6.875 9.5774 6.875 10.0837C6.875 10.5899 7.28541 11.0003 7.79167 11.0003Z"
            fill="#62638A"
        />
        <path
            d="M10.9997 11.0003C11.5059 11.0003 11.9163 10.5899 11.9163 10.0837C11.9163 9.5774 11.5059 9.16699 10.9997 9.16699C10.4934 9.16699 10.083 9.5774 10.083 10.0837C10.083 10.5899 10.4934 11.0003 10.9997 11.0003Z"
            fill="#62638A"
        />
        <path
            d="M14.2087 11.0003C14.7149 11.0003 15.1253 10.5899 15.1253 10.0837C15.1253 9.5774 14.7149 9.16699 14.2087 9.16699C13.7024 9.16699 13.292 9.5774 13.292 10.0837C13.292 10.5899 13.7024 11.0003 14.2087 11.0003Z"
            fill="#62638A"
        />
    </svg>
);

export const apps = (
    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M7.33301 2.52148H4.58301C3.44392 2.52148 2.52051 3.4449 2.52051 4.58398V7.33398C2.52051 8.47307 3.44392 9.39648 4.58301 9.39648H7.33301C8.4721 9.39648 9.39551 8.47307 9.39551 7.33398V4.58398C9.39551 3.4449 8.4721 2.52148 7.33301 2.52148Z"
            stroke="#62638A"
            strokeWidth="1.5"
        />
        <path
            d="M17.417 2.52148H14.667C13.5279 2.52148 12.6045 3.4449 12.6045 4.58398V7.33398C12.6045 8.47307 13.5279 9.39648 14.667 9.39648H17.417C18.5561 9.39648 19.4795 8.47307 19.4795 7.33398V4.58398C19.4795 3.4449 18.5561 2.52148 17.417 2.52148Z"
            stroke="#62638A"
            strokeWidth="1.5"
        />
        <path
            d="M17.417 12.6035H14.667C13.5279 12.6035 12.6045 13.5269 12.6045 14.666V17.416C12.6045 18.5551 13.5279 19.4785 14.667 19.4785H17.417C18.5561 19.4785 19.4795 18.5551 19.4795 17.416V14.666C19.4795 13.5269 18.5561 12.6035 17.417 12.6035Z"
            stroke="#62638A"
            strokeWidth="1.5"
        />
        <path
            d="M7.33301 12.6035H4.58301C3.44392 12.6035 2.52051 13.5269 2.52051 14.666V17.416C2.52051 18.5551 3.44392 19.4785 4.58301 19.4785H7.33301C8.4721 19.4785 9.39551 18.5551 9.39551 17.416V14.666C9.39551 13.5269 8.4721 12.6035 7.33301 12.6035Z"
            stroke="#62638A"
            strokeWidth="1.5"
        />
    </svg>
);

export const settings = (
    <svg width="22" height="24" viewBox="0 0 22 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M2.65888 7.7589L3.46555 6.23469C3.94222 5.33403 5.01116 5.01425 5.84471 5.53925C7.28159 6.44425 8.45571 5.70573 8.45289 3.89107C8.45258 2.85165 9.23497 1.9934 10.1956 1.99807L12.0228 2.0057C12.8653 1.99367 13.5468 2.74616 13.5578 3.66532L13.5581 3.88486C13.5529 5.69452 14.7278 6.43452 16.1698 5.52986L16.3442 5.42032C17.0794 4.97116 18.0175 5.23867 18.4292 6.0407L19.3488 7.76307C19.8329 8.6684 19.5428 9.83665 18.7174 10.3561C17.2754 11.2608 17.2762 12.7393 18.7131 13.6443C19.5388 14.1643 19.8319 15.3304 19.3507 16.2397L18.544 17.7639C18.0673 18.6646 16.9983 18.9844 16.1648 18.4594C14.7279 17.5544 13.5538 18.2929 13.5566 20.1075C13.5524 21.1556 12.7746 22.0052 11.8138 22.0006L9.98673 21.9929C9.14415 22.005 8.46275 21.2525 8.45172 20.3333L8.45147 20.1138C8.45659 18.3041 7.28168 17.5641 5.83969 18.4688L5.66528 18.5783C4.93009 19.0275 3.99202 18.76 3.58029 17.9579L2.66067 16.2356C2.17659 15.3302 2.46675 14.162 3.29205 13.6425C4.73404 12.7379 4.73325 11.2594 3.29638 10.3544C2.46283 9.82935 2.18222 8.65956 2.65888 7.7589Z"
            stroke="#62638A"
            strokeWidth="1.5"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M13.9788 12C13.9788 10.2051 12.645 8.75 10.9997 8.75C9.35433 8.75 8.02051 10.2051 8.02051 12C8.02051 13.7949 9.35433 15.25 10.9997 15.25C12.645 15.25 13.9788 13.7949 13.9788 12Z"
            stroke="#62638A"
            strokeWidth="1.5"
        />
    </svg>
);

export const notification = (
    <svg width="15" height="19" viewBox="0 0 15 19" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M0.0631032 11.1733V10.9944C0.0936546 10.4214 0.274479 9.86636 0.587631 9.38426C1.1098 8.7992 1.46877 8.08854 1.62886 7.32293C1.668 6.73953 1.62886 6.14058 1.668 5.5494C1.94984 2.71021 4.76036 0.75 7.45346 0.75H7.53174C10.2718 0.75 13.0119 2.71021 13.3094 5.5494C13.3642 6.1328 13.3094 6.73953 13.3563 7.32293C13.5125 8.08988 13.872 8.8015 14.3976 9.38426C14.7243 9.86087 14.9114 10.4183 14.9378 10.9944V11.1733C14.9426 11.9494 14.6645 12.701 14.1549 13.2891C13.5011 13.9865 12.6124 14.421 11.6575 14.5104C8.86899 14.8682 6.04575 14.8682 3.25724 14.5104C2.31342 14.4137 1.43707 13.9797 0.791178 13.2891C0.297557 12.6953 0.0387074 11.9431 0.0631032 11.1733Z"
            fill="#1b3b5f"
        />
        <path
            opacity="0.4"
            d="M8.51819 15.7087C7.96235 15.6698 7.50828 15.7087 7.05421 15.7087C6.60389 15.7009 6.15431 15.7479 5.71549 15.8487C5.33971 15.9343 4.93262 16.1365 4.93262 16.5643C4.97205 16.9778 5.1962 17.3519 5.54326 17.5833C6.21181 18.0939 7.05429 18.3255 7.89189 18.229C8.70606 18.1689 9.45023 17.7493 9.91954 17.0855C10.1789 16.7492 10.1198 16.2685 9.78645 16.0043C9.39177 15.8114 8.95805 15.7103 8.51819 15.7087Z"
            fill="#1b3b5f"
        />
    </svg>
);

export const arrowRight = (
    <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g opacity="0.5">
            <path
                d="M6.375 2.83398L11.6875 8.14648L6.375 13.459"
                stroke="#1B1B1B"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </g>
    </svg>
);

export const logout = (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g opacity="0.5">
            <path
                d="M12 2.5L15 5.5M12 13.5V2.5V13.5ZM12 2.5L9 5.5L12 2.5Z"
                stroke="#1B1B1B"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M16 18H8C7.01367 18 6.69515 17.9953 6.45248 17.9569C4.95485 17.7197 3.78029 16.5451 3.54309 15.0475C3.50466 14.8048 3.5 14.4863 3.5 13.5C3.5 12.5137 3.50466 12.1952 3.54309 11.9525C3.78029 10.4549 4.95485 9.2803 6.45248 9.0431C6.69515 9.0047 7.01367 9 8 9H8.25C8.66421 9 9 8.66421 9 8.25C9 7.83579 8.66421 7.5 8.25 7.5H8C7.07099 7.5 6.60649 7.5 6.21783 7.56156C4.07837 7.90042 2.40042 9.5784 2.06156 11.7178C2 12.1065 2 12.571 2 13.5C2 14.429 2 14.8935 2.06156 15.2822C2.40042 17.4216 4.07836 19.0996 6.21783 19.4384C6.60649 19.5 7.07099 19.5 8 19.5H16C16.929 19.5 17.3935 19.5 17.7822 19.4384C19.9216 19.0996 21.5996 17.4216 21.9384 15.2822C22 14.8935 22 14.429 22 13.5C22 12.571 22 12.1065 21.9384 11.7178C21.5996 9.5784 19.9216 7.90042 17.7822 7.56156C17.3935 7.5 16.929 7.5 16 7.5H15.75C15.3358 7.5 15 7.83579 15 8.25C15 8.66421 15.3358 9 15.75 9H16C16.9863 9 17.3048 9.0047 17.5475 9.0431C19.0451 9.2803 20.2197 10.4549 20.4569 11.9525C20.4953 12.1952 20.5 12.5137 20.5 13.5C20.5 14.4863 20.4953 14.8048 20.4569 15.0475C20.2197 16.5451 19.0451 17.7197 17.5475 17.9569C17.3048 17.9953 16.9863 18 16 18Z"
                fill="#1B1B1B"
            />
        </g>
    </svg>
);

export const backbtn = (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M15 18L9 12L15 6"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);
export const delivery = (
    <svg width="27" height="24" viewBox="0 0 27 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M20.1103 14.4658C18.2595 14.4658 16.7539 15.8042 16.7539 17.4493C16.7539 19.0944 18.2595 20.4327 20.1103 20.4327C21.9614 20.4327 23.4667 19.0944 23.4667 17.4493C23.4667 15.8042 21.961 14.4658 20.1103 14.4658ZM20.1103 18.941C19.1848 18.941 18.4321 18.272 18.4321 17.4493C18.4321 16.6266 19.1848 15.9575 20.1103 15.9575C21.0358 15.9575 21.7885 16.6266 21.7885 17.4493C21.7885 18.272 21.0358 18.941 20.1103 18.941Z"
            fill="black"
        />
        <path
            d="M8.64271 14.4658C6.79195 14.4658 5.28632 15.8042 5.28632 17.4493C5.28632 19.0944 6.79195 20.4327 8.64271 20.4327C10.4935 20.4327 11.9991 19.0944 11.9991 17.4493C11.9991 15.8042 10.4935 14.4658 8.64271 14.4658ZM8.64271 18.941C7.7172 18.941 6.96451 18.272 6.96451 17.4493C6.96451 16.6266 7.7172 15.9575 8.64271 15.9575C9.56795 15.9575 10.3209 16.6266 10.3209 17.4493C10.3209 18.272 9.56821 18.941 8.64271 18.941Z"
            fill="black"
        />
        <path
            d="M22.3705 5.92636C22.2279 5.67451 21.9378 5.51562 21.6207 5.51562H17.2014V7.00735H21.1032L23.388 11.0469L24.8878 10.3766L22.3705 5.92636Z"
            fill="black"
        />
        <path d="M17.593 16.7285H11.2439V18.2202H17.593V16.7285Z" fill="black" />
        <path
            d="M6.1254 16.7285H3.21657C2.75309 16.7285 2.3775 17.0624 2.3775 17.4744C2.3775 17.8863 2.75314 18.2202 3.21657 18.2202H6.12545C6.58893 18.2202 6.96452 17.8863 6.96452 17.4744C6.96452 17.0624 6.58888 16.7285 6.1254 16.7285Z"
            fill="black"
        />
        <path
            d="M26.4511 12.1687L24.8006 10.2792C24.6421 10.0972 24.3973 9.9908 24.138 9.9908H18.0406V4.76977C18.0406 4.35778 17.6649 4.02393 17.2015 4.02393H3.21657C2.75309 4.02393 2.3775 4.35783 2.3775 4.76977C2.3775 5.1817 2.75314 5.51561 3.21657 5.51561H16.3624V10.7366C16.3624 11.1486 16.738 11.4825 17.2015 11.4825H23.7271L24.9491 12.8817V16.7284H22.6276C22.1641 16.7284 21.7885 17.0623 21.7885 17.4742C21.7885 17.8862 22.1642 18.2201 22.6276 18.2201H25.7882C26.2517 18.2201 26.6273 17.8862 26.6273 17.4742V12.6262C26.6273 12.4606 26.5652 12.2995 26.4511 12.1687Z"
            fill="black"
        />
        <path
            d="M6.06948 12.9492H2.20962C1.74613 12.9492 1.37054 13.2831 1.37054 13.6951C1.37054 14.107 1.74619 14.4409 2.20962 14.4409H6.06943C6.53291 14.4409 6.9085 14.107 6.9085 13.6951C6.9085 13.2831 6.53291 12.9492 6.06948 12.9492Z"
            fill="black"
        />
        <path
            d="M7.99937 10.0156H0.839072C0.375642 10.0156 0 10.3495 0 10.7615C0 11.1735 0.375642 11.5074 0.839072 11.5074H7.99937C8.46285 11.5074 8.83844 11.1735 8.83844 10.7615C8.83844 10.3496 8.46285 10.0156 7.99937 10.0156Z"
            fill="black"
        />
        <path
            d="M9.36991 7.08203H2.20962C1.74613 7.08203 1.37054 7.41594 1.37054 7.82787C1.37054 8.23986 1.74619 8.57371 2.20962 8.57371H9.36991C9.83339 8.57371 10.209 8.23981 10.209 7.82787C10.209 7.41594 9.83339 7.08203 9.36991 7.08203Z"
            fill="black"
        />
    </svg>
);
export const location = (
    <svg width="20" height="24" viewBox="0 0 20 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M19 10C19 17 10 23 10 23C10 23 1 17 1 10C1 7.61305 1.94821 5.32387 3.63604 3.63604C5.32387 1.94821 7.61305 1 10 1C12.3869 1 14.6761 1.94821 16.364 3.63604C18.0518 5.32387 19 7.61305 19 10Z"
            stroke="#090A0A"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M10 13C11.6569 13 13 11.6569 13 10C13 8.34315 11.6569 7 10 7C8.34315 7 7 8.34315 7 10C7 11.6569 8.34315 13 10 13Z"
            stroke="#090A0A"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);
export const downloadBtn = (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M4 12V20C4 20.5304 4.21071 21.0391 4.58579 21.4142C4.96086 21.7893 5.46957 22 6 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V12M16 6L12 2M12 2L8 6M12 2L12 15"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);
export const send = (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M22 2L11 13M22 2L15 22L11 13M22 2L2 9L11 13"
            stroke="#404446"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);
export const blackHome = (
    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M2.75 8.24992L11 1.83325L19.25 8.24992V18.3333C19.25 18.8195 19.0568 19.2858 18.713 19.6296C18.3692 19.9734 17.9029 20.1666 17.4167 20.1666H4.58333C4.0971 20.1666 3.63079 19.9734 3.28697 19.6296C2.94315 19.2858 2.75 18.8195 2.75 18.3333V8.24992Z"
            stroke="#090A0A"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);
export const stepper = (
    <svg width="40" height="8" viewBox="0 0 40 8" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M0 4C0 1.79086 1.79086 0 4 0C6.20914 0 8 1.79086 8 4C8 6.20914 6.20914 8 4 8C1.79086 8 0 6.20914 0 4Z"
            fill="#E3E5E6"
        />
        <path
            d="M16 4C16 1.79086 17.7909 0 20 0C22.2091 0 24 1.79086 24 4C24 6.20914 22.2091 8 20 8C17.7909 8 16 6.20914 16 4Z"
            fill="#1b3b5f"
        />
        <path
            d="M32 4C32 1.79086 33.7909 0 36 0C38.2091 0 40 1.79086 40 4C40 6.20914 38.2091 8 36 8C33.7909 8 32 6.20914 32 4Z"
            fill="#E3E5E6"
        />
    </svg>
);
export const hamburger = (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M4 9.33325H28" stroke="#181717" strokeWidth="1.5" strokeLinecap="round" />
        <path d="M4 16H25.3333" stroke="#181717" strokeWidth="1.5" strokeLinecap="round" />
        <path d="M4 22.6667H22.6667" stroke="#181717" strokeWidth="1.5" strokeLinecap="round" />
    </svg>
);
export const openMenu = (
    <svg width="57" height="57" viewBox="0 0 57 57" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="28.5" cy="28.5" r="28.5" fill="#1b3b5f" />
        <path
            d="M28.5544 39.4561C29.3315 39.4561 29.9728 38.8202 29.9728 38.0431V28.5543C29.9728 28.5434 29.9728 28.5271 29.9728 28.5163C29.9728 28.5054 29.9728 28.4945 29.9728 28.4782C29.9673 28.4673 29.9673 28.4565 29.9673 28.4402C29.9673 28.4293 29.9619 28.4184 29.9619 28.4021C29.9565 28.3913 29.9565 28.3804 29.9565 28.3641C29.951 28.3532 29.951 28.3423 29.951 28.326C29.9456 28.3152 29.9456 28.3043 29.9456 28.2934C29.9456 28.2826 29.9402 28.2663 29.9402 28.2554C29.9347 28.2445 29.9347 28.2337 29.9347 28.2228C29.9293 28.2119 29.9293 28.2011 29.9239 28.1902C29.7663 27.5761 29.2119 27.125 28.5544 27.125H18.9569C18.1797 27.125 17.5385 27.7608 17.5385 28.5434C17.5385 29.3206 18.1743 29.9564 18.9569 29.9564H25.1034L20.7883 34.2715C20.2394 34.8204 20.2394 35.7225 20.7883 36.2714C21.3372 36.8203 22.2394 36.8203 22.7937 36.2714L27.1359 31.9292V38.0322C27.1359 38.8148 27.7718 39.4561 28.5544 39.4561Z"
            fill="white"
        />
        <path
            d="M20.7177 20.7883C20.1688 21.3372 20.1688 22.2393 20.7177 22.7937L23.6143 25.6903C24.1632 26.2392 25.0653 26.2392 25.6196 25.6903C26.174 25.1414 26.174 24.2338 25.6196 23.6849L22.723 20.7883C22.1687 20.234 21.2665 20.234 20.7177 20.7883Z"
            fill="white"
        />
        <path
            d="M28.4511 17.5383C27.6739 17.5383 27.0326 18.1742 27.0326 18.9513V23.049C27.0326 23.8316 27.6685 24.462 28.4511 24.462C29.2336 24.462 29.8695 23.8261 29.8695 23.049V18.9513C29.8695 18.1796 29.2336 17.5383 28.4511 17.5383Z"
            fill="white"
        />
        <path
            d="M36.2171 20.7122C35.6682 20.1633 34.7606 20.1633 34.2117 20.7122L31.3151 23.6088C30.7662 24.1577 30.7662 25.0599 31.3151 25.6088C31.864 26.1631 32.7715 26.1631 33.3204 25.6088L36.2171 22.7121C36.766 22.1632 36.766 21.2665 36.2171 20.7122Z"
            fill="white"
        />
        <path
            d="M39.4615 28.4457C39.4615 27.6686 38.8257 27.0327 38.0431 27.0327H33.9454C33.1628 27.0327 32.5324 27.6686 32.5324 28.4457C32.5324 29.2283 33.1683 29.8641 33.9454 29.8641H38.0431C38.8257 29.8641 39.4615 29.2283 39.4615 28.4457Z"
            fill="white"
        />
        <path
            d="M36.2877 36.206C36.8366 35.6571 36.8366 34.7495 36.2877 34.2006L33.3911 31.304C32.8422 30.7551 31.9401 30.7551 31.3857 31.304C30.8369 31.8529 30.8369 32.7605 31.3857 33.3094L34.2824 36.206C34.8367 36.7603 35.7388 36.7603 36.2877 36.206Z"
            fill="white"
        />
    </svg>
);
export const tag = (
    <svg width="38" height="38" viewBox="0 0 38 38" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M11.0833 11.0833H11.0992M32.6008 21.2325L21.2483 32.585C20.9542 32.8794 20.605 33.113 20.2206 33.2723C19.8361 33.4317 19.4241 33.5137 19.0079 33.5137C18.5918 33.5137 18.1797 33.4317 17.7953 33.2723C17.4109 33.113 17.0616 32.8794 16.7675 32.585L3.16667 19V3.16663H19L32.6008 16.7675C33.1906 17.3608 33.5217 18.1634 33.5217 19C33.5217 19.8365 33.1906 20.6391 32.6008 21.2325Z"
            stroke="#090A0A"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);
export const videoLogo = (
    <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M26.8333 8.16659L18.6667 13.9999L26.8333 19.8333V8.16659Z"
            stroke="white"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M16.3333 5.83325H3.5C2.21133 5.83325 1.16666 6.87792 1.16666 8.16659V19.8333C1.16666 21.1219 2.21133 22.1666 3.5 22.1666H16.3333C17.622 22.1666 18.6667 21.1219 18.6667 19.8333V8.16659C18.6667 6.87792 17.622 5.83325 16.3333 5.83325Z"
            stroke="white"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);
export const heart = (
    <svg width="20" height="19" viewBox="0 0 20 19" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M17.612 2.50292C17.1722 2.02645 16.65 1.64848 16.0752 1.39061C15.5005 1.13273 14.8844 1 14.2623 1C13.6401 1 13.0241 1.13273 12.4493 1.39061C11.8746 1.64848 11.3524 2.02645 10.9126 2.50292L9.99977 3.4913L9.08699 2.50292C8.19858 1.54094 6.99364 1.0005 5.73725 1.0005C4.48085 1.0005 3.27591 1.54094 2.38751 2.50292C1.4991 3.46491 1 4.76964 1 6.1301C1 7.49055 1.4991 8.79528 2.38751 9.75727L3.30029 10.7457L9.99977 18L16.6992 10.7457L17.612 9.75727C18.0521 9.28102 18.4011 8.71557 18.6393 8.0932C18.8774 7.47084 19 6.80377 19 6.1301C19 5.45642 18.8774 4.78935 18.6393 4.16699C18.4011 3.54463 18.0521 2.97917 17.612 2.50292V2.50292Z"
            stroke="#090A0A"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export const productImport = (
    <svg width="19" height="17" viewBox="0 0 19 17" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M6.33334 12.4583L9.50001 15.6249M9.50001 15.6249L12.6667 12.4583M9.50001 15.6249V8.49995M16.53 13.3212C17.2183 12.8372 17.7344 12.1465 18.0035 11.3493C18.2726 10.5521 18.2807 9.68984 18.0266 8.88773C17.7724 8.08561 17.2693 7.38535 16.5902 6.88856C15.9111 6.39176 15.0914 6.12429 14.25 6.12495H13.2525C13.0144 5.19701 12.5689 4.33518 11.9495 3.60434C11.3301 2.8735 10.553 2.29269 9.67672 1.90564C8.80039 1.51859 7.84768 1.33539 6.8903 1.36981C5.93293 1.40424 4.99583 1.65541 4.14957 2.10441C3.30331 2.55341 2.56994 3.18854 2.00466 3.96198C1.43938 4.73542 1.05693 5.62702 0.886092 6.56967C0.715258 7.51231 0.760494 8.48142 1.01839 9.40405C1.2763 10.3267 1.74014 11.1788 2.37501 11.8962"
            stroke="#090A0A"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export const userIcon = (
    <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M20.25 21V19C20.25 17.9391 19.8286 16.9217 19.0784 16.1716C18.3283 15.4214 17.3109 15 16.25 15H8.25C7.18913 15 6.17172 15.4214 5.42157 16.1716C4.67143 16.9217 4.25 17.9391 4.25 19V21"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M12.25 11C14.4591 11 16.25 9.20914 16.25 7C16.25 4.79086 14.4591 3 12.25 3C10.0409 3 8.25 4.79086 8.25 7C8.25 9.20914 10.0409 11 12.25 11Z"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export const bellIcon = (
    <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M14.23 21C14.0542 21.3031 13.8018 21.5547 13.4982 21.7295C13.1946 21.9044 12.8504 21.9965 12.5 21.9965C12.1496 21.9965 11.8054 21.9044 11.5018 21.7295C11.1982 21.5547 10.9458 21.3031 10.77 21M18.5 8C18.5 6.4087 17.8679 4.88258 16.7426 3.75736C15.6174 2.63214 14.0913 2 12.5 2C10.9087 2 9.38258 2.63214 8.25736 3.75736C7.13214 4.88258 6.5 6.4087 6.5 8C6.5 15 3.5 17 3.5 17H21.5C21.5 17 18.5 15 18.5 8Z"
            stroke="#979C9E"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export const homeIcon = (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M3 9L12 2L21 9V20C21 20.5304 20.7893 21.0391 20.4142 21.4142C20.0391 21.7893 19.5304 22 19 22H5C4.46957 22 3.96086 21.7893 3.58579 21.4142C3.21071 21.0391 3 20.5304 3 20V9Z"
            stroke="#979C9E"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export const heartNav = (
    <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M21.59 4.61012C21.0793 4.09912 20.4728 3.69376 19.8054 3.4172C19.1379 3.14064 18.4225 2.99829 17.7 2.99829C16.9775 2.99829 16.2621 3.14064 15.5947 3.4172C14.9272 3.69376 14.3208 4.09912 13.81 4.61012L12.75 5.67012L11.69 4.61012C10.6583 3.57842 9.25907 2.99883 7.80003 2.99883C6.341 2.99883 4.94172 3.57842 3.91003 4.61012C2.87834 5.64181 2.29874 7.04108 2.29874 8.50012C2.29874 9.95915 2.87834 11.3584 3.91003 12.3901L4.97003 13.4501L12.75 21.2301L20.53 13.4501L21.59 12.3901C22.101 11.8794 22.5064 11.2729 22.7829 10.6055C23.0595 9.93801 23.2019 9.2226 23.2019 8.50012C23.2019 7.77763 23.0595 7.06222 22.7829 6.39476C22.5064 5.7273 22.101 5.12087 21.59 4.61012V4.61012Z"
            stroke="#979C9E"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);
export const cartIcon = (
    <svg width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M1.09806 0.0244802C0.827278 -0.0296758 0.563866 0.145933 0.50971 0.416712C0.455554 0.687492 0.631162 0.950905 0.901942 1.00506L1.09806 0.0244802ZM3.52 3.66477L3.02238 3.71453L3.02356 3.72434L3.52 3.66477ZM18.2855 6.5226L17.8005 6.40134L18.2855 6.5226ZM3.3972 2.4368L2.89968 2.48655L3.3972 2.4368ZM0.901942 1.00506L1.7013 1.16493L1.89742 0.184352L1.09806 0.0244802L0.901942 1.00506ZM6.37435 13.1648H14.0173V12.1648H6.37435V13.1648ZM17.8979 10.1349L18.7706 6.64387L17.8005 6.40134L16.9277 9.89238L17.8979 10.1349ZM2.89968 2.48655L3.02248 3.71452L4.01752 3.61502L3.89472 2.38704L2.89968 2.48655ZM3.02356 3.72434L3.89216 10.9626L4.88503 10.8435L4.01644 3.6052L3.02356 3.72434ZM16.0542 3.16477H3.52V4.16477H16.0542V3.16477ZM18.7706 6.64387C19.2124 4.87666 17.8758 3.16477 16.0542 3.16477V4.16477C17.2252 4.16477 18.0845 5.26527 17.8005 6.40134L18.7706 6.64387ZM14.0173 13.1648C15.8528 13.1648 17.4527 11.9156 17.8979 10.1349L16.9277 9.89238C16.5938 11.2279 15.3939 12.1648 14.0173 12.1648V13.1648ZM6.37435 12.1648C5.61505 12.1648 4.9755 11.5974 4.88503 10.8435L3.89216 10.9626C4.04294 12.2191 5.10885 13.1648 6.37435 13.1648V12.1648ZM1.7013 1.16493C2.3478 1.29423 2.83408 1.83052 2.89968 2.48655L3.89472 2.38704C3.78538 1.29366 2.97492 0.399852 1.89742 0.184352L1.7013 1.16493Z"
            fill="#090A0A"
        />
        <path
            d="M10.8999 9.96484H7.29993"
            stroke="#090A0A"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <circle cx="6.85" cy="15.8147" r="1.35" fill="#090A0A" />
        <circle cx="14.95" cy="15.8147" r="1.35" fill="#090A0A" />
    </svg>
);
export const whiteCart = (
    <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_957_12585)">
            <path
                d="M2.56248 6.39993L1.33876 1.60839H0V0.855225H1.92373L2.21221 1.98475L10 1.97918L9.17204 6.39989H2.56248V6.39993ZM2.40451 2.73778L3.14745 5.64675H8.54685L9.09257 2.73299L2.40451 2.73778Z"
                fill="white"
            />
            <path
                d="M3.59349 9.1447C2.92937 9.1447 2.38906 8.60438 2.38906 7.94026C2.38906 7.27613 2.92937 6.73584 3.59349 6.73584H8.1313C8.79543 6.73584 9.33574 7.27613 9.33574 7.94026C9.33574 8.60438 8.79544 9.1447 8.1313 9.1447C7.46717 9.1447 6.92688 8.60438 6.92688 7.94026C6.92688 7.78076 6.95812 7.62845 7.01467 7.489H4.71012C4.76668 7.62845 4.79793 7.78076 4.79793 7.94026C4.79792 8.60438 4.25761 9.1447 3.59349 9.1447ZM7.68004 7.94026C7.68004 8.1891 7.88247 8.39153 8.1313 8.39153C8.38014 8.39153 8.58258 8.1891 8.58258 7.94026C8.58258 7.69144 8.38015 7.489 8.1313 7.489C7.88247 7.489 7.68004 7.69144 7.68004 7.94026ZM3.14221 7.94026C3.14221 8.1891 3.34465 8.39153 3.59348 8.39153C3.84231 8.39153 4.04474 8.1891 4.04474 7.94026C4.04474 7.69144 3.84231 7.489 3.59348 7.489C3.34465 7.489 3.14221 7.69144 3.14221 7.94026Z"
                fill="white"
            />
        </g>
        <defs>
            <clipPath id="clip0_957_12585">
                <rect width="10" height="10" fill="white" transform="matrix(-1 0 0 1 10 0)" />
            </clipPath>
        </defs>
    </svg>
);
export const blackheart = (
    <svg width="12" height="10" viewBox="0 0 12 10" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M6.31 9.40505C6.14 9.46505 5.86 9.46505 5.69 9.40505C4.24 8.91005 1 6.84505 1 3.34505C1 1.80005 2.245 0.550049 3.78 0.550049C4.69 0.550049 5.495 0.990049 6 1.67005C6.505 0.990049 7.315 0.550049 8.22 0.550049C9.755 0.550049 11 1.80005 11 3.34505C11 6.84505 7.76 8.91005 6.31 9.40505Z"
            stroke="#121212"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);
export const filter = (
    <svg width="15" height="11" viewBox="0 0 15 11" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M15 10.5H5V8.83333H15V10.5ZM15 6.33333H0V4.66667H15V6.33333ZM15 2.16667H5V0.5H15V2.16667Z"
            fill="black"
        />
    </svg>
);
export const whitecartIcon = (
    <svg width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M1.09806 0.0244802C0.827278 -0.0296758 0.563866 0.145933 0.50971 0.416712C0.455554 0.687492 0.631162 0.950905 0.901942 1.00506L1.09806 0.0244802ZM3.52 3.66477L3.02238 3.71453L3.02356 3.72434L3.52 3.66477ZM18.2855 6.5226L17.8005 6.40134L18.2855 6.5226ZM3.3972 2.4368L2.89968 2.48655L3.3972 2.4368ZM0.901942 1.00506L1.7013 1.16493L1.89742 0.184352L1.09806 0.0244802L0.901942 1.00506ZM6.37435 13.1648H14.0173V12.1648H6.37435V13.1648ZM17.8979 10.1349L18.7706 6.64387L17.8005 6.40134L16.9277 9.89238L17.8979 10.1349ZM2.89968 2.48655L3.02248 3.71452L4.01752 3.61502L3.89472 2.38704L2.89968 2.48655ZM3.02356 3.72434L3.89216 10.9626L4.88503 10.8435L4.01644 3.6052L3.02356 3.72434ZM16.0542 3.16477H3.52V4.16477H16.0542V3.16477ZM18.7706 6.64387C19.2124 4.87666 17.8758 3.16477 16.0542 3.16477V4.16477C17.2252 4.16477 18.0845 5.26527 17.8005 6.40134L18.7706 6.64387ZM14.0173 13.1648C15.8528 13.1648 17.4527 11.9156 17.8979 10.1349L16.9277 9.89238C16.5938 11.2279 15.3939 12.1648 14.0173 12.1648V13.1648ZM6.37435 12.1648C5.61505 12.1648 4.9755 11.5974 4.88503 10.8435L3.89216 10.9626C4.04294 12.2191 5.10885 13.1648 6.37435 13.1648V12.1648ZM1.7013 1.16493C2.3478 1.29423 2.83408 1.83052 2.89968 2.48655L3.89472 2.38704C3.78538 1.29366 2.97492 0.399852 1.89742 0.184352L1.7013 1.16493Z"
            fill="white"
        />
        <path
            d="M10.8999 9.96484H7.29993"
            stroke="white"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <circle cx="6.85" cy="15.8147" r="1.35" fill="white" />
        <circle cx="14.95" cy="15.8147" r="1.35" fill="white" />
    </svg>
);

export const downArrow = (
    <svg width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g opacity="0.3">
            <path
                d="M11.6667 5.625L7.29175 10.3125L2.91675 5.625"
                stroke="#1B1B1B"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </g>
    </svg>
);
export const actions = (
    <svg width="17" height="3" viewBox="0 0 17 3" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M8.5625 0.875C8.87316 0.875 9.125 1.12684 9.125 1.4375C9.125 1.74816 8.87316 2 8.5625 2C8.25184 2 8 1.74816 8 1.4375C8 1.12684 8.25184 0.875 8.5625 0.875Z"
            fill="#090A0A"
        />
        <path
            d="M15.5625 0.875C15.8732 0.875 16.125 1.12684 16.125 1.4375C16.125 1.74816 15.8732 2 15.5625 2C15.2518 2 15 1.74816 15 1.4375C15 1.12684 15.2518 0.875 15.5625 0.875Z"
            fill="#090A0A"
        />
        <path
            d="M1.5625 0.875C1.87316 0.875 2.125 1.12684 2.125 1.4375C2.125 1.74816 1.87316 2 1.5625 2C1.25184 2 1 1.74816 1 1.4375C1 1.12684 1.25184 0.875 1.5625 0.875Z"
            fill="#090A0A"
        />
        <path
            d="M8.5625 0.875C8.87316 0.875 9.125 1.12684 9.125 1.4375C9.125 1.74816 8.87316 2 8.5625 2C8.25184 2 8 1.74816 8 1.4375C8 1.12684 8.25184 0.875 8.5625 0.875Z"
            stroke="#090A0A"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M15.5625 0.875C15.8732 0.875 16.125 1.12684 16.125 1.4375C16.125 1.74816 15.8732 2 15.5625 2C15.2518 2 15 1.74816 15 1.4375C15 1.12684 15.2518 0.875 15.5625 0.875Z"
            stroke="#090A0A"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M1.5625 0.875C1.87316 0.875 2.125 1.12684 2.125 1.4375C2.125 1.74816 1.87316 2 1.5625 2C1.25184 2 1 1.74816 1 1.4375C1 1.12684 1.25184 0.875 1.5625 0.875Z"
            stroke="#090A0A"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

// export const deleteIcon = (
//   <svg
//     width="16"
//     height="18"
//     viewBox="0 0 16 18"
//     fill="none"
//     xmlns="http://www.w3.org/2000/svg"
//   >
//     <path
//       d="M2.2549 5.45652C1.52676 4.48567 2.21949 3.10022 3.43305 3.10022H13.0546C14.2682 3.10022 14.9609 4.48567 14.2328 5.45652V5.45652C13.7017 6.16463 13.4146 7.02588 13.4146 7.91101V12.889C13.4146 15.0981 11.6238 16.889 9.41461 16.889H7.07306C4.86392 16.889 3.07306 15.0981 3.07306 12.889V7.91101C3.07306 7.02588 2.78598 6.16463 2.2549 5.45652V5.45652Z"
//       stroke="#090A0A"
//     />
//     <path
//       d="M9.96753 12.5798L9.96753 7.40906"
//       stroke="#090A0A"
//       strokeLinecap="round"
//       strokeLinejoin="round"
//     />
//     <path
//       d="M6.52026 12.5798L6.52026 7.40906"
//       stroke="#090A0A"
//       strokeLinecap="round"
//       strokeLinejoin="round"
//     />
//     <path
//       d="M11.691 3.10016L11.2851 1.88231C11.0128 1.06563 10.2485 0.514771 9.38768 0.514771H7.09995C6.23908 0.514771 5.47481 1.06563 5.20258 1.88232L4.79663 3.10016"
//       stroke="#090A0A"
//       strokeLinecap="round"
//     />
//   </svg>
// );

// export const search = (
//   <svg
//     width="24"
//     height="24"
//     viewBox="0 0 24 24"
//     fill="none"
//     xmlns="http://www.w3.org/2000/svg"
//   >
//     <path
//       d="M21 21L16.65 16.65M19 11C19 15.4183 15.4183 19 11 19C6.58172 19 3 15.4183 3 11C3 6.58172 6.58172 3 11 3C15.4183 3 19 6.58172 19 11Z"
//       stroke="#090A0A"
//       strokeWidth="1.5"
//       strokeLinecap="round"
//       strokeLinejoin="round"
//     />
//   </svg>
// );

// export const listIcon = (
//   <svg
//     width="25"
//     height="25"
//     viewBox="0 0 25 25"
//     fill="none"
//     xmlns="http://www.w3.org/2000/svg"
//   >
//     <path
//       d="M8.33333 6.25H21.875M8.33333 12.5H21.875M8.33333 18.75H21.875M3.125 6.25H3.13542M3.125 12.5H3.13542M3.125 18.75H3.13542"
//       stroke="#090A0A"
//       strokeWidth="1.5"
//       strokeLinecap="round"
//       strokeLinejoin="round"
//     />
//   </svg>
// );
// export const lockIcon = (
//   <svg
//     width="20"
//     height="22"
//     viewBox="0 0 20 22"
//     fill="none"
//     xmlns="http://www.w3.org/2000/svg"
//   >
//     <path
//       d="M5 10V6C5 4.67392 5.52678 3.40215 6.46447 2.46447C7.40215 1.52678 8.67392 1 10 1C11.3261 1 12.5979 1.52678 13.5355 2.46447C14.4732 3.40215 15 4.67392 15 6V10M3 10H17C18.1046 10 19 10.8954 19 12V19C19 20.1046 18.1046 21 17 21H3C1.89543 21 1 20.1046 1 19V12C1 10.8954 1.89543 10 3 10Z"
//       stroke="#090A0A"
//       strokeWidth="1.5"
//       strokeLinecap="round"
//       strokeLinejoin="round"
//     />
//   </svg>
// );

// export const cardIcon = (
//   <svg
//     width="24"
//     height="18"
//     viewBox="0 0 24 18"
//     fill="none"
//     xmlns="http://www.w3.org/2000/svg"
//   >
//     <path
//       d="M1 7H23M3 1H21C22.1046 1 23 1.89543 23 3V15C23 16.1046 22.1046 17 21 17H3C1.89543 17 1 16.1046 1 15V3C1 1.89543 1.89543 1 3 1Z"
//       stroke="#090A0A"
//       strokeWidth="1.5"
//       strokeLinecap="round"
//       strokeLinejoin="round"
//     />
//   </svg>
// );
// export const locationIcon = (
//   <svg
//     width="20"
//     height="24"
//     viewBox="0 0 20 24"
//     fill="none"
//     xmlns="http://www.w3.org/2000/svg"
//   >
//     <path
//       d="M19 10C19 17 10 23 10 23C10 23 1 17 1 10C1 7.61305 1.94821 5.32387 3.63604 3.63604C5.32387 1.94821 7.61305 1 10 1C12.3869 1 14.6761 1.94821 16.364 3.63604C18.0518 5.32387 19 7.61305 19 10Z"
//       stroke="#090A0A"
//       strokeWidth="1.5"
//       strokeLinecap="round"
//       strokeLinejoin="round"
//     />
//     <path
//       d="M10 13C11.6569 13 13 11.6569 13 10C13 8.34315 11.6569 7 10 7C8.34315 7 7 8.34315 7 10C7 11.6569 8.34315 13 10 13Z"
//       stroke="#090A0A"
//       strokeWidth="1.5"
//       strokeLinecap="round"
//       strokeLinejoin="round"
//     />
//   </svg>
// );
// export const helpIcon = (
//   <svg
//     width="22"
//     height="22"
//     viewBox="0 0 22 22"
//     fill="none"
//     xmlns="http://www.w3.org/2000/svg"
//   >
//     <path
//       d="M8.09 8C8.3251 7.33167 8.78915 6.76811 9.39995 6.40913C10.0108 6.05016 10.7289 5.91894 11.4272 6.03871C12.1255 6.15849 12.7588 6.52152 13.2151 7.06353C13.6713 7.60553 13.9211 8.29152 13.92 9C13.92 11 10.92 12 10.92 12M11 16H11.01M21 11C21 16.5228 16.5228 21 11 21C5.47715 21 1 16.5228 1 11C1 5.47715 5.47715 1 11 1C16.5228 1 21 5.47715 21 11Z"
//       stroke="#090A0A"
//       strokeWidth="1.5"
//       strokeLinecap="round"
//       strokeLinejoin="round"
//     />
//   </svg>
// );
// export const blackUser = (
//   <svg
//     width="18"
//     height="20"
//     viewBox="0 0 18 20"
//     fill="none"
//     xmlns="http://www.w3.org/2000/svg"
//   >
//     <path
//       d="M17 19V17C17 15.9391 16.5786 14.9217 15.8284 14.1716C15.0783 13.4214 14.0609 13 13 13H5C3.93913 13 2.92172 13.4214 2.17157 14.1716C1.42143 14.9217 1 15.9391 1 17V19"
//       stroke="#090A0A"
//       strokeWidth="1.5"
//       strokeLinecap="round"
//       strokeLinejoin="round"
//     />
//     <path
//       d="M9 9C11.2091 9 13 7.20914 13 5C13 2.79086 11.2091 1 9 1C6.79086 1 5 2.79086 5 5C5 7.20914 6.79086 9 9 9Z"
//       stroke="#090A0A"
//       strokeWidth="1.5"
//       strokeLinecap="round"
//       strokeLinejoin="round"
//     />
//   </svg>
// );
// export const blackBellIcon = (
//   <svg
//     width="25"
//     height="24"
//     viewBox="0 0 25 24"
//     fill="none"
//     xmlns="http://www.w3.org/2000/svg"
//   >
//     <path
//       d="M14.23 21C14.0542 21.3031 13.8018 21.5547 13.4982 21.7295C13.1946 21.9044 12.8504 21.9965 12.5 21.9965C12.1496 21.9965 11.8054 21.9044 11.5018 21.7295C11.1982 21.5547 10.9458 21.3031 10.77 21M18.5 8C18.5 6.4087 17.8679 4.88258 16.7426 3.75736C15.6174 2.63214 14.0913 2 12.5 2C10.9087 2 9.38258 2.63214 8.25736 3.75736C7.13214 4.88258 6.5 6.4087 6.5 8C6.5 15 3.5 17 3.5 17H21.5C21.5 17 18.5 15 18.5 8Z"
//       stroke="#090A0A"
//       strokeWidth="1.5"
//       strokeLinecap="round"
//       strokeLinejoin="round"
//     />
//   </svg>
// );
// export const blackStar = (
//   <svg
//     width="22"
//     height="21"
//     viewBox="0 0 22 21"
//     fill="none"
//     xmlns="http://www.w3.org/2000/svg"
//   >
//     <path
//       d="M11 1L14.09 7.26L21 8.27L16 13.14L17.18 20.02L11 16.77L4.82 20.02L6 13.14L1 8.27L7.91 7.26L11 1Z"
//       stroke="#090A0A"
//       strokeWidth="1.5"
//       strokeLinecap="round"
//       strokeLinejoin="round"
//     />
//   </svg>
// );
export const calendar = (
    <svg width="15" height="18" viewBox="0 0 15 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M11.2101 1.27925V2.14166C13.7174 2.3849 15 3.77066 15 6.26207V13.154C15 15.9255 13.4203 17.3334 10.3116 17.3334H4.68841C1.57971 17.3334 0 15.9255 0 13.154V6.26207C0 4.60359 0.565217 3.41685 1.72464 2.72397C1.9074 2.59922 2.14386 2.59051 2.33501 2.70149C2.52617 2.81247 2.63906 3.02399 2.62641 3.24751C2.61377 3.47102 2.47777 3.66798 2.27536 3.75592C1.50725 4.21292 1.14493 5.00899 1.14493 6.26207V6.4832H11.7174C12.0336 6.4832 12.2899 6.74391 12.2899 7.06551C12.2899 7.38711 12.0336 7.64782 11.7174 7.64782H1.14493V13.154C1.14493 15.2695 2.17391 16.1466 4.68841 16.1614H10.3116C12.7899 16.1614 13.8478 15.2621 13.8478 13.1466V6.2547C13.8478 4.41194 13.0435 3.52004 11.2101 3.30628V3.86648C11.1679 4.16507 10.9109 4.38305 10.6145 4.37168C10.3181 4.3603 10.078 4.12324 10.058 3.82226V1.22765C10.0636 1.07184 10.1304 0.924826 10.2435 0.819531C10.3565 0.714236 10.5063 0.659455 10.6594 0.667455C10.975 0.687196 11.2185 0.957713 11.2101 1.27925ZM4.75735 4.24401C4.64842 4.35343 4.50094 4.41391 4.34786 4.41194C4.03454 4.4039 3.78582 4.14105 3.78989 3.82226V1.27925C3.82284 0.980927 4.07085 0.755395 4.36598 0.755395C4.6611 0.755395 4.90912 0.980927 4.94207 1.27925V2.08269H8.21743C8.53359 2.08269 8.78989 2.3434 8.78989 2.66501C8.78989 2.98661 8.53359 3.24732 8.21743 3.24732H4.92757V3.82963C4.92759 3.98535 4.86628 4.13459 4.75735 4.24401ZM10.9928 9.51273C10.5926 9.51273 10.2681 9.84274 10.2681 10.2498C10.2681 10.6569 10.5926 10.9869 10.9928 10.9869C11.393 10.9869 11.7174 10.6569 11.7174 10.2498C11.7174 10.0531 11.6401 9.86444 11.5026 9.726C11.3652 9.58755 11.179 9.51076 10.9855 9.51273H10.9928ZM6.78979 10.2498C6.78979 9.84272 7.11422 9.5127 7.51443 9.5127C7.91463 9.5127 8.23906 9.84272 8.23906 10.2498C8.23906 10.6569 7.91463 10.9869 7.51443 10.9869C7.11422 10.9869 6.78979 10.6569 6.78979 10.2498ZM4.04349 9.51273C3.64329 9.51273 3.31885 9.84274 3.31885 10.2498C3.31885 10.6569 3.64329 10.9869 4.04349 10.9869C4.4437 10.9869 4.76813 10.6569 4.76813 10.2498C4.76814 10.0531 4.6908 9.86444 4.55333 9.726C4.41587 9.58755 4.22968 9.51076 4.03625 9.51273H4.04349ZM10.2681 13.2351C10.2681 12.828 10.5926 12.498 10.9928 12.498H10.9855C11.179 12.496 11.3652 12.5728 11.5026 12.7112C11.6401 12.8497 11.7174 13.0383 11.7174 13.2351C11.7174 13.6422 11.393 13.9722 10.9928 13.9722C10.5926 13.9722 10.2681 13.6422 10.2681 13.2351ZM7.51443 12.4979C7.11422 12.4979 6.78979 12.828 6.78979 13.235C6.78979 13.6421 7.11422 13.9721 7.51443 13.9721C7.91463 13.9721 8.23906 13.6421 8.23906 13.235C8.23906 12.828 7.91463 12.4979 7.51443 12.4979ZM3.31885 13.2351C3.31885 12.828 3.64329 12.498 4.04349 12.498H4.03625C4.22968 12.496 4.41587 12.5728 4.55333 12.7112C4.6908 12.8497 4.76814 13.0383 4.76813 13.2351C4.76813 13.6422 4.4437 13.9722 4.04349 13.9722C3.64329 13.9722 3.31885 13.6422 3.31885 13.2351Z"
            fill="#353542"
        />
    </svg>
);
export const setting = (
    <svg width="13" height="15" viewBox="0 0 13 15" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M1.73419 0.549314L1.73419 8.89039C1.11469 9.11971 0.667114 9.76393 0.667114 10.5214C0.667114 11.2788 1.11469 11.923 1.73419 12.1523V13.4543C1.73419 13.7568 1.95721 14.002 2.23231 14.002C2.5074 14.002 2.73043 13.7568 2.73043 13.4543V12.1523C3.34992 11.923 3.7975 11.2788 3.7975 10.5213C3.7975 9.76389 3.34992 9.11967 2.73043 8.89036L2.73043 0.549278C2.73043 0.246831 2.5074 0.00163078 2.23231 0.00163078C1.95721 0.00163078 1.73419 0.246831 1.73419 0.549314ZM2.80126 10.5214C2.80126 10.8663 2.54602 11.1469 2.23231 11.1469C1.91859 11.1469 1.66335 10.8663 1.66335 10.5214C1.66335 10.1765 1.91859 9.89584 2.23231 9.89584C2.54602 9.89584 2.80126 10.1765 2.80126 10.5214Z"
            fill="black"
        />
        <path
            d="M6.00225 0.549314V1.85133C5.38276 2.08065 4.93518 2.7249 4.93518 3.4823C4.93518 4.23969 5.38276 4.88391 6.00225 5.11323V13.4543C6.00225 13.7568 6.22528 14.002 6.50037 14.002C6.77547 14.002 6.99849 13.7568 6.99849 13.4543V5.11323C7.61799 4.88391 8.06556 4.23966 8.06556 3.48226C8.06556 2.72486 7.61799 2.08061 6.99849 1.85129V0.549278C6.99849 0.246831 6.77547 0.00163078 6.50037 0.00163078C6.22528 0.00163078 6.00225 0.246831 6.00225 0.549314ZM7.06932 3.48226C7.06932 3.82717 6.81409 4.10778 6.50037 4.10778C6.18666 4.10778 5.93142 3.82717 5.93142 3.48226C5.93142 3.13735 6.18666 2.85674 6.50037 2.85674C6.81409 2.85674 7.06932 3.13735 7.06932 3.48226Z"
            fill="black"
        />
        <path
            d="M10.2703 0.547789V6.54249C9.65082 6.77181 9.20325 7.41602 9.20325 8.17346C9.20325 8.93089 9.65082 9.5751 10.2703 9.80442V13.4528C10.2703 13.7552 10.4933 14.0004 10.7684 14.0004C11.0435 14.0004 11.2666 13.7552 11.2666 13.4528V9.80442C11.8861 9.5751 12.3336 8.93089 12.3336 8.17346C12.3336 7.41602 11.8861 6.77181 11.2666 6.54249V0.547752C11.2666 0.245305 11.0435 0.000104904 10.7684 0.000104904C10.4933 0.000104904 10.2703 0.245305 10.2703 0.547789ZM11.3374 8.17346C11.3374 8.51836 11.0822 8.79898 10.7685 8.79898C10.4548 8.79898 10.1995 8.51836 10.1995 8.17346C10.1995 7.82855 10.4547 7.54793 10.7684 7.54793C11.0822 7.54793 11.3374 7.82855 11.3374 8.17346Z"
            fill="black"
        />
    </svg>
);

export const myStore = (
    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M7.33325 2.52081H4.58325C3.44416 2.52081 2.52075 3.44423 2.52075 4.58331V7.33331C2.52075 8.4724 3.44416 9.39581 4.58325 9.39581H7.33325C8.47234 9.39581 9.39575 8.4724 9.39575 7.33331V4.58331C9.39575 3.44423 8.47234 2.52081 7.33325 2.52081Z"
            stroke="#1b3b5f"
            stroke-width="1.5"
        />
        <path
            d="M17.4167 2.52081H14.6667C13.5277 2.52081 12.6042 3.44423 12.6042 4.58331V7.33331C12.6042 8.4724 13.5277 9.39581 14.6667 9.39581H17.4167C18.5558 9.39581 19.4792 8.4724 19.4792 7.33331V4.58331C19.4792 3.44423 18.5558 2.52081 17.4167 2.52081Z"
            stroke="#1b3b5f"
            stroke-width="1.5"
        />
        <path
            d="M17.4167 12.6042H14.6667C13.5277 12.6042 12.6042 13.5276 12.6042 14.6667V17.4167C12.6042 18.5558 13.5277 19.4792 14.6667 19.4792H17.4167C18.5558 19.4792 19.4792 18.5558 19.4792 17.4167V14.6667C19.4792 13.5276 18.5558 12.6042 17.4167 12.6042Z"
            stroke="#1b3b5f"
            stroke-width="1.5"
        />
        <path
            d="M7.33325 12.6042H4.58325C3.44416 12.6042 2.52075 13.5276 2.52075 14.6667V17.4167C2.52075 18.5558 3.44416 19.4792 4.58325 19.4792H7.33325C8.47234 19.4792 9.39575 18.5558 9.39575 17.4167V14.6667C9.39575 13.5276 8.47234 12.6042 7.33325 12.6042Z"
            stroke="#1b3b5f"
            stroke-width="1.5"
        />
    </svg>
);

export const oBIcons = {
    logistices: (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M6.09658 2.49246C6.3424 2.33586 6.65668 2.33584 6.9025 2.49243L12.0003 5.73963L17.097 2.49247C17.3428 2.33584 17.6572 2.33584 17.903 2.49247L23.403 5.99657C23.6191 6.13428 23.75 6.37282 23.75 6.6291C23.75 6.88539 23.6191 7.12393 23.403 7.26163L18.8958 10.1332L23.403 13.0048C23.6191 13.1425 23.75 13.381 23.75 13.6373C23.75 13.8936 23.6191 14.1321 23.403 14.2698L18.7966 17.2045L19.0161 17.3508C19.2247 17.4899 19.35 17.7241 19.35 17.9748C19.35 18.2256 19.2247 18.4598 19.0161 18.5989L12.4166 22.999C12.1647 23.167 11.8365 23.167 11.5845 22.9991L4.98402 18.599C4.77536 18.4599 4.65002 18.2257 4.65002 17.975C4.65003 17.7242 4.77536 17.49 4.98403 17.3509L5.20369 17.2045L0.597006 14.2695C0.380862 14.1318 0.25 13.8932 0.25 13.637C0.25 13.3807 0.380868 13.1421 0.597013 13.0044L5.10423 10.1329L0.597006 7.26129C0.380862 7.12358 0.25 6.88504 0.25 6.62875C0.25 6.37247 0.380868 6.13393 0.597013 5.99622L6.09658 2.49246ZM10.5792 13.6211L9.51096 14.3332L6.4996 16.2515L2.39582 13.637L6.49961 11.0225L10.5792 13.6211ZM14.5264 14.3576L13.4215 13.6209L17.5 11.0225L21.6042 13.6373L17.5 16.252L14.5264 14.3576ZM10.33 15.59L6.75218 17.975L12.0005 21.4736L17.248 17.9749L13.7072 15.6142L11.9996 14.5264L10.33 15.59ZM11.9996 7.51815L16.1042 10.1332L12.0003 12.7478L7.89506 10.1329L11.9996 7.51815ZM6.49961 4.01425L2.39582 6.62877L6.4996 9.24333L10.604 6.6287L6.49961 4.01425ZM13.3958 6.6291L17.5 9.24392L21.6042 6.6291L17.5 4.01428L13.3958 6.6291Z"
                fill="#1b3b5f"
            />
        </svg>
    ),
    rfq: (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
                d="M15.75 13C15.75 12.5858 15.4142 12.25 15 12.25H9C8.58579 12.25 8.25 12.5858 8.25 13C8.25 13.4142 8.58579 13.75 9 13.75H15C15.4142 13.75 15.75 13.4142 15.75 13Z"
                fill="#1b3b5f"
            />
            <path
                d="M15.75 17C15.75 16.5858 15.4142 16.25 15 16.25H9C8.58579 16.25 8.25 16.5858 8.25 17C8.25 17.4142 8.58579 17.75 9 17.75H15C15.4142 17.75 15.75 17.4142 15.75 17Z"
                fill="#1b3b5f"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M7 2.25C5.48122 2.25 4.25 3.48122 4.25 5V19C4.25 20.5188 5.48122 21.75 7 21.75H17C18.5188 21.75 19.75 20.5188 19.75 19V7.96766C19.75 7.58689 19.6258 7.21651 19.3963 6.9127L16.3985 2.94504C16.0677 2.5073 15.5509 2.25 15.0022 2.25H7ZM5.75 5C5.75 4.30964 6.30964 3.75 7 3.75H14.25V8.14705C14.25 8.56126 14.5858 8.89705 15 8.89705H18.25V19C18.25 19.6904 17.6904 20.25 17 20.25H7C6.30964 20.25 5.75 19.6904 5.75 19V5Z"
                fill="#1b3b5f"
            />
        </svg>
    ),
    finInventory: (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
                d="M13.5 9.7502C13.5 9.33599 13.1642 9.0002 12.75 9.0002H6.75C6.33579 9.0002 6 9.33599 6 9.7502C6 10.1644 6.33579 10.5002 6.75 10.5002H12.75C13.1642 10.5002 13.5 10.1644 13.5 9.7502Z"
                fill="#1b3b5f"
            />
            <path
                d="M12.5 12.7502C12.5 12.336 12.1642 12.0002 11.75 12.0002H6.75C6.33579 12.0002 6 12.336 6 12.7502C6 13.1644 6.33579 13.5002 6.75 13.5002H11.75C12.1642 13.5002 12.5 13.1644 12.5 12.7502Z"
                fill="#1b3b5f"
            />
            <path
                d="M12.75 15.0002C13.1642 15.0002 13.5 15.336 13.5 15.7502C13.5 16.1644 13.1642 16.5002 12.75 16.5002H6.75C6.33579 16.5002 6 16.1644 6 15.7502C6 15.336 6.33579 15.0002 6.75 15.0002H12.75Z"
                fill="#1b3b5f"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M6 21.7502H19C20.5188 21.7502 21.75 20.519 21.75 19.0002V13.5002C21.75 13.086 21.4142 12.7502 21 12.7502H17.75V4.9434C17.75 3.51999 16.1411 2.69203 14.9828 3.51936L14.8078 3.6444C14.0273 4.20189 12.9701 4.20002 12.1859 3.63991C10.8821 2.70857 9.11794 2.70857 7.81407 3.63991C7.02992 4.20002 5.9727 4.20189 5.19221 3.6444L5.01717 3.51936C3.8589 2.69203 2.25 3.51999 2.25 4.9434V18.0002C2.25 20.0713 3.92893 21.7502 6 21.7502ZM8.68593 4.86051C9.46825 4.30171 10.5318 4.30171 11.3141 4.86051C12.6161 5.79053 14.3739 5.79764 15.6796 4.865L15.8547 4.73996C16.0202 4.62177 16.25 4.74005 16.25 4.9434V19.0002C16.25 19.4503 16.3581 19.8752 16.5499 20.2502H6C4.75736 20.2502 3.75 19.2428 3.75 18.0002V4.9434C3.75 4.74005 3.97984 4.62177 4.14531 4.73996L4.32036 4.865C5.62605 5.79764 7.3839 5.79053 8.68593 4.86051ZM17.75 19.0002V14.2502H20.25V19.0002C20.25 19.6906 19.6904 20.2502 19 20.2502C18.3096 20.2502 17.75 19.6906 17.75 19.0002Z"
                fill="#1b3b5f"
            />
        </svg>
    ),
    crm: (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
                d="M17 21V19C17 17.9391 16.5786 16.9217 15.8284 16.1716C15.0783 15.4214 14.0609 15 13 15H5C3.93913 15 2.92172 15.4214 2.17157 16.1716C1.42143 16.9217 1 17.9391 1 19V21M23 21V19C22.9993 18.1137 22.7044 17.2528 22.1614 16.5523C21.6184 15.8519 20.8581 15.3516 20 15.13M16 3.13C16.8604 3.3503 17.623 3.8507 18.1676 4.55231C18.7122 5.25392 19.0078 6.11683 19.0078 7.005C19.0078 7.89317 18.7122 8.75608 18.1676 9.45769C17.623 10.1593 16.8604 10.6597 16 10.88M13 7C13 9.20914 11.2091 11 9 11C6.79086 11 5 9.20914 5 7C5 4.79086 6.79086 3 9 3C11.2091 3 13 4.79086 13 7Z"
                stroke="#1b3b5f"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    ),
    tasks: (
        <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
                d="M4.3628 1.10938C4.32796 1.07442 4.28656 1.04668 4.24098 1.02775C4.1954 1.00883 4.14653 0.999084 4.09717 0.999084C4.04782 0.999084 3.99895 1.00883 3.95336 1.02775C3.90778 1.04668 3.86638 1.07442 3.83155 1.10938L1.84155 3.08782L1.13217 2.39657C1.09733 2.36161 1.05593 2.33387 1.01035 2.31494C0.964771 2.29601 0.915901 2.28627 0.866546 2.28627C0.81719 2.28627 0.768321 2.29601 0.722739 2.31494C0.677157 2.33387 0.635759 2.36161 0.600921 2.39657L0.110296 2.88782C0.0753357 2.92266 0.0475969 2.96405 0.0286699 3.00964C0.00974286 3.05522 0 3.10409 0 3.15344C0 3.2028 0.00974286 3.25167 0.0286699 3.29725C0.0475969 3.34283 0.0753357 3.38423 0.110296 3.41907L1.59748 4.90032C1.67172 4.97088 1.77022 5.01023 1.87264 5.01023C1.97506 5.01023 2.07356 4.97088 2.1478 4.90032L2.63498 4.41219L4.89123 2.15626C4.96153 2.0859 5.00125 1.99066 5.00178 1.89121C5.00231 1.79175 4.9636 1.6961 4.89405 1.62501L4.3628 1.10938ZM4.3628 6.08407C4.32796 6.04911 4.28656 6.02137 4.24098 6.00244C4.1954 5.98351 4.14653 5.97377 4.09717 5.97377C4.04782 5.97377 3.99895 5.98351 3.95336 6.00244C3.90778 6.02137 3.86638 6.04911 3.83155 6.08407L1.84155 8.07532L1.13217 7.38469C1.09733 7.34973 1.05593 7.32199 1.01035 7.30307C0.964771 7.28414 0.915901 7.2744 0.866546 7.2744C0.81719 7.2744 0.768321 7.28414 0.722739 7.30307C0.677157 7.32199 0.635759 7.34973 0.600921 7.38469L0.110296 7.87501C0.0753357 7.90984 0.0475969 7.95124 0.0286699 7.99682C0.00974286 8.04241 0 8.09128 0 8.14063C0 8.18999 0.00974286 8.23886 0.0286699 8.28444C0.0475969 8.33002 0.0753357 8.37142 0.110296 8.40626L1.59373 9.89063C1.66791 9.96117 1.76637 10.0005 1.86873 10.0005C1.9711 10.0005 2.06955 9.96117 2.14373 9.89063L2.63436 9.40032L4.89061 7.14344C4.96064 7.07358 5.00023 6.97888 5.00075 6.87996C5.00128 6.78104 4.9627 6.68592 4.89342 6.61532L4.3628 6.08407ZM1.99998 11.5C1.17217 11.5 0.481546 12.1719 0.481546 13C0.481546 13.8281 1.1728 14.5 1.99998 14.5C2.39781 14.5 2.77934 14.342 3.06064 14.0607C3.34195 13.7794 3.49998 13.3978 3.49998 13C3.49998 12.6022 3.34195 12.2206 3.06064 11.9393C2.77934 11.658 2.39781 11.5 1.99998 11.5ZM15.5 12H6.49998C6.36737 12 6.2402 12.0527 6.14643 12.1465C6.05266 12.2402 5.99998 12.3674 5.99998 12.5V13.5C5.99998 13.6326 6.05266 13.7598 6.14643 13.8536C6.2402 13.9473 6.36737 14 6.49998 14H15.5C15.6326 14 15.7598 13.9473 15.8535 13.8536C15.9473 13.7598 16 13.6326 16 13.5V12.5C16 12.3674 15.9473 12.2402 15.8535 12.1465C15.7598 12.0527 15.6326 12 15.5 12ZM15.5 2.00001H6.49998C6.36737 2.00001 6.2402 2.05268 6.14643 2.14645C6.05266 2.24022 5.99998 2.3674 5.99998 2.50001V3.50001C5.99998 3.63261 6.05266 3.75979 6.14643 3.85356C6.2402 3.94733 6.36737 4.00001 6.49998 4.00001H15.5C15.6326 4.00001 15.7598 3.94733 15.8535 3.85356C15.9473 3.75979 16 3.63261 16 3.50001V2.50001C16 2.3674 15.9473 2.24022 15.8535 2.14645C15.7598 2.05268 15.6326 2.00001 15.5 2.00001ZM15.5 7.00001H6.49998C6.36737 7.00001 6.2402 7.05268 6.14643 7.14645C6.05266 7.24022 5.99998 7.3674 5.99998 7.50001V8.50001C5.99998 8.63261 6.05266 8.75979 6.14643 8.85356C6.2402 8.94733 6.36737 9 6.49998 9H15.5C15.6326 9 15.7598 8.94733 15.8535 8.85356C15.9473 8.75979 16 8.63261 16 8.50001V7.50001C16 7.3674 15.9473 7.24022 15.8535 7.14645C15.7598 7.05268 15.6326 7.00001 15.5 7.00001Z"
                fill="currentColor"
            />
        </svg>
    ),
    meeting: (
        <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
                d="M15.8332 3.33335H14.1665V2.50002C14.1665 2.27901 14.0787 2.06704 13.9224 1.91076C13.7661 1.75448 13.5542 1.66669 13.3332 1.66669C13.1122 1.66669 12.9002 1.75448 12.7439 1.91076C12.5876 2.06704 12.4998 2.27901 12.4998 2.50002V3.33335H7.49984V2.50002C7.49984 2.27901 7.41204 2.06704 7.25576 1.91076C7.09948 1.75448 6.88752 1.66669 6.6665 1.66669C6.44549 1.66669 6.23353 1.75448 6.07725 1.91076C5.92097 2.06704 5.83317 2.27901 5.83317 2.50002V3.33335H4.1665C3.50346 3.33335 2.86758 3.59675 2.39874 4.06559C1.9299 4.53443 1.6665 5.17031 1.6665 5.83335V15.8334C1.6665 16.4964 1.9299 17.1323 2.39874 17.6011C2.86758 18.07 3.50346 18.3334 4.1665 18.3334H15.8332C16.4962 18.3334 17.1321 18.07 17.6009 17.6011C18.0698 17.1323 18.3332 16.4964 18.3332 15.8334V5.83335C18.3332 5.17031 18.0698 4.53443 17.6009 4.06559C17.1321 3.59675 16.4962 3.33335 15.8332 3.33335ZM16.6665 15.8334C16.6665 16.0544 16.5787 16.2663 16.4224 16.4226C16.2661 16.5789 16.0542 16.6667 15.8332 16.6667H4.1665C3.94549 16.6667 3.73353 16.5789 3.57725 16.4226C3.42097 16.2663 3.33317 16.0544 3.33317 15.8334V10H16.6665V15.8334ZM16.6665 8.33335H3.33317V5.83335C3.33317 5.61234 3.42097 5.40038 3.57725 5.2441C3.73353 5.08782 3.94549 5.00002 4.1665 5.00002H5.83317V5.83335C5.83317 6.05437 5.92097 6.26633 6.07725 6.42261C6.23353 6.57889 6.44549 6.66669 6.6665 6.66669C6.88752 6.66669 7.09948 6.57889 7.25576 6.42261C7.41204 6.26633 7.49984 6.05437 7.49984 5.83335V5.00002H12.4998V5.83335C12.4998 6.05437 12.5876 6.26633 12.7439 6.42261C12.9002 6.57889 13.1122 6.66669 13.3332 6.66669C13.5542 6.66669 13.7661 6.57889 13.9224 6.42261C14.0787 6.26633 14.1665 6.05437 14.1665 5.83335V5.00002H15.8332C16.0542 5.00002 16.2661 5.08782 16.4224 5.2441C16.5787 5.40038 16.6665 5.61234 16.6665 5.83335V8.33335Z"
                fill="currentColor"
            />
        </svg>
    ),
    quote: (
        <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
                d="M14.1948 5.82501C14.0136 6.00432 13.7691 6.1049 13.5142 6.1049C13.2593 6.1049 13.0147 6.00432 12.8335 5.82501C12.7442 5.73666 12.6732 5.63144 12.6248 5.51547C12.5763 5.3995 12.5514 5.27506 12.5514 5.14938C12.5514 5.0237 12.5763 4.89927 12.6248 4.7833C12.6732 4.66732 12.7442 4.56211 12.8335 4.47376C13.0147 4.29407 13.2596 4.19325 13.5148 4.19325C13.77 4.19325 14.0148 4.29407 14.196 4.47376C14.571 4.84751 14.571 5.45251 14.196 5.82501M3.17104 11.45C2.9371 11.2187 2.75137 10.9432 2.62462 10.6396C2.49786 10.336 2.43259 10.0103 2.43259 9.68126C2.43259 9.35225 2.49786 9.02651 2.62462 8.7229C2.75137 8.41929 2.9371 8.14385 3.17104 7.91251L9.11729 2.00001C9.58787 1.53314 10.2232 1.27004 10.886 1.26751L14.9673 1.25001C15.2992 1.24753 15.6282 1.31092 15.9354 1.43651C16.2426 1.5621 16.5219 1.74739 16.7569 1.98166C16.992 2.21593 17.1783 2.49451 17.3049 2.80127C17.4316 3.10804 17.4961 3.43688 17.4948 3.76876L17.4635 7.98501C17.4575 8.64264 17.1925 9.27139 16.726 9.73501L10.8648 15.56C10.3918 16.0298 9.75212 16.2935 9.08542 16.2935C8.41871 16.2935 7.77907 16.0298 7.30604 15.56L3.17104 11.45ZM4.05979 8.79626C3.94297 8.91201 3.85024 9.04976 3.78696 9.20156C3.72368 9.35335 3.69109 9.51618 3.69109 9.68063C3.69109 9.84509 3.72368 10.0079 3.78696 10.1597C3.85024 10.3115 3.94297 10.4493 4.05979 10.565L8.19729 14.6775C8.68854 15.165 9.48479 15.165 9.97729 14.6775L15.8373 8.85001C16.0705 8.6182 16.203 8.30382 16.206 7.97501L16.236 3.75876C16.2365 3.59311 16.2042 3.429 16.141 3.27589C16.0778 3.12278 15.9848 2.98371 15.8676 2.86669C15.7503 2.74968 15.6111 2.65703 15.4578 2.59409C15.3046 2.53116 15.1404 2.49918 14.9748 2.50001L10.8935 2.51751C10.562 2.51758 10.2442 2.64932 10.0098 2.88376L4.05979 8.79626ZM2.49604 12.1875C2.32812 12.6369 2.29305 13.1251 2.395 13.5939C2.49696 14.0627 2.73164 14.4922 3.07104 14.8313L5.52604 17.2863C5.99034 17.7506 6.54154 18.1189 7.14819 18.3702C7.75483 18.6215 8.40504 18.7508 9.06167 18.7508C9.7183 18.7508 10.3685 18.6215 10.9751 18.3702C11.5818 18.1189 12.133 17.7506 12.5973 17.2863L16.9498 12.9338C17.3015 12.5825 17.4994 12.1059 17.4998 11.6088V10.6338L12.5973 15.5363C12.5123 15.6229 12.4244 15.705 12.3335 15.7825L11.7135 16.4025C11.3653 16.7508 10.9519 17.0271 10.4969 17.2156C10.0419 17.4041 9.55418 17.5011 9.06167 17.5011C8.56916 17.5011 8.08147 17.4041 7.62646 17.2156C7.17144 17.0271 6.75802 16.7508 6.40979 16.4025L5.78729 15.7788C5.69778 15.701 5.61106 15.6201 5.52729 15.5363L3.07104 13.0813C2.81754 12.828 2.62144 12.5232 2.49604 12.1875Z"
                fill="currentColor"
            />
        </svg>
    ),
    bargain: (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
                d="M11.7022 19.942C11.8329 19.942 11.9669 19.9126 12.1042 19.854C12.2415 19.7953 12.3525 19.7236 12.4372 19.639L20.2332 11.842C20.4845 11.5906 20.6785 11.334 20.8152 11.072C20.9512 10.8086 21.0192 10.52 21.0192 10.206C21.0192 9.88796 20.9512 9.57929 20.8152 9.27996C20.6785 8.97996 20.4845 8.70662 20.2332 8.45996L16.4832 4.70996C16.2359 4.45862 15.9815 4.27429 15.7202 4.15696C15.4595 4.03962 15.1702 3.98096 14.8522 3.98096C14.5382 3.98096 14.2465 4.03962 13.9772 4.15696C13.7079 4.27429 13.4542 4.45829 13.2162 4.70896L12.3442 5.58096L14.1942 7.43596C14.3929 7.63129 14.5412 7.85329 14.6392 8.10196C14.7365 8.35062 14.7852 8.60296 14.7852 8.85896C14.7852 9.37962 14.6149 9.81029 14.2742 10.151C13.9335 10.4916 13.5032 10.6616 12.9832 10.661C12.7265 10.661 12.4762 10.622 12.2322 10.544C11.9882 10.466 11.7685 10.3293 11.5732 10.134L10.1022 8.66996C9.98686 8.55462 9.83953 8.49696 9.66019 8.49696C9.48019 8.49696 9.33253 8.55462 9.21719 8.66996L5.34219 12.545C5.24153 12.6463 5.16586 12.7613 5.11519 12.89C5.06453 13.0186 5.03919 13.1486 5.03919 13.28C5.03919 13.516 5.11486 13.7103 5.26619 13.863C5.41686 14.0163 5.61019 14.093 5.84619 14.093C5.97686 14.093 6.11086 14.0636 6.24819 14.005C6.38553 13.9456 6.49653 13.8736 6.58119 13.789L9.39619 10.974C9.48953 10.8806 9.60353 10.8296 9.73819 10.821C9.87286 10.8123 9.99486 10.8633 10.1042 10.974C10.2109 11.0806 10.2642 11.1986 10.2642 11.328C10.2642 11.4573 10.2109 11.5753 10.1042 11.682L7.29419 14.497C7.19286 14.5983 7.11686 14.7133 7.06619 14.842C7.01619 14.9713 6.99119 15.1013 6.99119 15.232C6.99119 15.4553 7.06986 15.6456 7.22719 15.803C7.38453 15.9603 7.57486 16.0393 7.79819 16.04C7.92886 16.04 8.06286 16.0103 8.20019 15.951C8.33753 15.8916 8.44853 15.82 8.53319 15.736L11.5792 12.696C11.6725 12.602 11.7862 12.5506 11.9202 12.542C12.0542 12.5333 12.1762 12.5843 12.2862 12.695C12.3929 12.8016 12.4462 12.9196 12.4462 13.049C12.4462 13.1783 12.3929 13.2963 12.2862 13.403L9.24619 16.449C9.15819 16.5336 9.08553 16.6446 9.02819 16.782C8.97086 16.9193 8.94219 17.0533 8.94219 17.184C8.94219 17.4066 9.02119 17.5966 9.17919 17.754C9.33719 17.9126 9.52753 17.992 9.75019 17.992C9.88086 17.992 10.0109 17.9666 10.1402 17.916C10.2695 17.8653 10.3842 17.7893 10.4842 17.688L13.5312 14.648C13.6245 14.554 13.7382 14.5026 13.8722 14.494C14.0062 14.486 14.1285 14.537 14.2392 14.647C14.3452 14.7536 14.3982 14.8716 14.3982 15.001C14.3982 15.1303 14.3449 15.2483 14.2382 15.355L11.1932 18.4C11.0925 18.5013 11.0169 18.623 10.9662 18.765C10.9155 18.907 10.8902 19.0366 10.8902 19.154C10.8902 19.39 10.9732 19.5803 11.1392 19.725C11.3052 19.8696 11.4932 19.942 11.7032 19.942M11.6972 20.942C11.1832 20.942 10.7432 20.754 10.3772 20.378C10.0112 20.002 9.85053 19.5373 9.89519 18.984C9.32853 18.9906 8.85686 18.8216 8.48019 18.477C8.10353 18.1323 7.92453 17.651 7.94319 17.033C7.32586 17.0396 6.83919 16.863 6.48319 16.503C6.12719 16.143 5.96519 15.669 5.99719 15.081C5.44119 15.0876 4.97586 14.931 4.60119 14.611C4.22719 14.2923 4.04019 13.8483 4.04019 13.279C4.04019 13.0223 4.08986 12.7656 4.18919 12.509C4.28853 12.2516 4.43519 12.0256 4.62919 11.831L8.52419 7.93596C8.83086 7.62996 9.20886 7.47696 9.65819 7.47696C10.1075 7.47696 10.4855 7.63029 10.7922 7.93696L12.2432 9.38796C12.3279 9.47662 12.4325 9.54962 12.5572 9.60696C12.6819 9.66429 12.8222 9.69262 12.9782 9.69196C13.1922 9.69196 13.3812 9.61729 13.5452 9.46796C13.7092 9.31862 13.7915 9.12396 13.7922 8.88396C13.7922 8.72796 13.7635 8.58796 13.7062 8.46396C13.6489 8.33929 13.5762 8.23462 13.4882 8.14996L10.0482 4.70996C9.80019 4.45862 9.54253 4.27429 9.27519 4.15696C9.00786 4.03962 8.71519 3.98096 8.39719 3.98096C8.08319 3.98096 7.79786 4.03962 7.54119 4.15696C7.28519 4.27429 7.03153 4.45862 6.78019 4.70996L3.73519 7.75996C3.38586 8.10862 3.16119 8.53429 3.06119 9.03696C2.96119 9.53962 3.00686 10.0196 3.19819 10.477C3.23553 10.6063 3.21886 10.7313 3.14819 10.852C3.07753 10.9726 2.97753 11.0493 2.84819 11.082C2.71886 11.1146 2.59053 11.0973 2.46319 11.03C2.33586 10.9626 2.25586 10.8636 2.22319 10.733C2.00786 10.0863 1.96086 9.43329 2.08219 8.77396C2.20353 8.11462 2.51686 7.53229 3.02219 7.02696L6.04619 4.00196C6.39486 3.65662 6.76386 3.39996 7.15319 3.23196C7.54253 3.06462 7.96353 2.98096 8.41619 2.98096C8.86886 2.98096 9.28619 3.06496 9.66819 3.23296C10.0509 3.40029 10.4149 3.65662 10.7602 4.00196L11.6302 4.87296L12.5022 4.00196C12.8509 3.65662 13.2165 3.39996 13.5992 3.23196C13.9819 3.06462 14.3995 2.98096 14.8522 2.98096C15.3049 2.98096 15.7259 3.06496 16.1152 3.23296C16.5039 3.40029 16.8705 3.65662 17.2152 4.00196L20.9412 7.72696C21.2859 8.07162 21.5519 8.45862 21.7392 8.88796C21.9265 9.31729 22.0199 9.75829 22.0192 10.211C22.0192 10.6643 21.9259 11.082 21.7392 11.464C21.5525 11.846 21.2865 12.21 20.9412 12.556L13.1442 20.346C12.9369 20.554 12.7109 20.7053 12.4662 20.8C12.2222 20.8946 11.9665 20.942 11.6972 20.942Z"
                fill="currentColor"
            />
        </svg>
    ),
    sampleRequest: (
        <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
                d="M16.25 18.75H3.75C3.41848 18.75 3.10054 18.6183 2.86612 18.3839C2.6317 18.1495 2.5 17.8315 2.5 17.5V10C2.5 9.66848 2.6317 9.35054 2.86612 9.11612C3.10054 8.8817 3.41848 8.75 3.75 8.75H5.625V10H3.75V17.5H16.25V10H14.375V8.75H16.25C16.5815 8.75 16.8995 8.8817 17.1339 9.11612C17.3683 9.35054 17.5 9.66848 17.5 10V17.5C17.5 17.8315 17.3683 18.1495 17.1339 18.3839C16.8995 18.6183 16.5815 18.75 16.25 18.75Z"
                fill="currentColor"
            />
            <path
                d="M8.125 12.5H11.875V13.75H8.125V12.5ZM12.8688 5.36875L10.625 7.60625V1.25H9.375V7.60625L7.13125 5.36875L6.25 6.25L10 10L13.75 6.25L12.8688 5.36875Z"
                fill="currentColor"
            />
        </svg>
    ),
    crmSuccess: (
        <svg
            width="95"
            height="89"
            viewBox="0 0 95 89"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
                d="M79.5476 10.5919L54.3587 3.86227C45.222 1.42125 38.4689 5.33414 36.0127 14.4741L27.6938 45.4301C25.1973 54.7199 29.1157 61.3554 38.2524 63.7964L63.4413 70.5261C72.7252 73.0065 79.2959 69.1733 81.7923 59.8835L90.1112 28.9275C92.5674 19.7875 88.8315 13.0723 79.5476 10.5919Z"
                fill="url(#paint0_linear_1355_3789)"
            />
            <g opacity="0.5" filter="url(#filter0_f_1355_3789)">
                <path
                    d="M72.9657 19.0689L55.8043 14.4839C49.5794 12.8208 44.9784 15.4867 43.305 21.7139L37.6373 42.8045C35.9364 49.1337 38.6061 53.6546 44.8309 55.3177L61.9924 59.9027C68.3176 61.5925 72.7943 58.981 74.4951 52.6517L80.1629 31.5611C81.8363 25.334 79.291 20.7588 72.9657 19.0689Z"
                    fill="#39B93A"
                />
            </g>
            <foreignObject x="-24" y="-8.39072" width="121.6" height="121.391">
                <div
                    xmlns="http://www.w3.org/1999/xhtml"
                    style={{
                        backdropFilter: 'blur(12px)',
                        clipPath: 'url(#bgblur_0_1355_3789_clip_path)',
                        height: '100%',
                        width: '100%',
                    }}></div>
            </foreignObject>
            <g data-figma-bg-blur-radius="24">
                <mask
                    id="path-3-outside-1_1355_3789"
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="15.6093"
                    width="74"
                    height="74"
                    fill="black">
                    <rect fill="white" y="15.6093" width="74" height="74" />
                    <path d="M52.3369 16.6093H21.2985C9.16235 16.6093 1 25.1048 1 37.7409V66.904C1 79.5045 9.16235 88 21.2985 88H52.3369C64.473 88 72.5996 79.5045 72.5996 66.904V37.7409C72.5996 25.1048 64.473 16.6093 52.3369 16.6093Z" />
                </mask>
                <path
                    d="M52.3369 16.6093H21.2985C9.16235 16.6093 1 25.1048 1 37.7409V66.904C1 79.5045 9.16235 88 21.2985 88H52.3369C64.473 88 72.5996 79.5045 72.5996 66.904V37.7409C72.5996 25.1048 64.473 16.6093 52.3369 16.6093Z"
                    fill="#39B93A"
                    fillOpacity="0.35"
                />
                <path
                    d="M52.3369 17.6093C52.8892 17.6093 53.3369 17.1616 53.3369 16.6093C53.3369 16.057 52.8892 15.6093 52.3369 15.6093V17.6093ZM52.3369 15.6093C51.7846 15.6093 51.3369 16.057 51.3369 16.6093C51.3369 17.1616 51.7846 17.6093 52.3369 17.6093V15.6093ZM52.3369 16.6093V15.6093H21.2985V16.6093V17.6093H52.3369V16.6093ZM21.2985 16.6093V15.6093C14.9886 15.6093 9.64322 17.8233 5.87703 21.7438C2.11419 25.6608 0 31.2053 0 37.7409H1H2C2 31.6405 3.96698 26.6191 7.31935 23.1293C10.6684 19.6431 15.4723 17.6093 21.2985 17.6093V16.6093ZM1 37.7409H0V66.904H1H2V37.7409H1ZM1 66.904H0C0 73.4226 2.11464 78.9581 5.87745 82.8704C9.64352 86.7861 14.9886 89 21.2985 89V88V87C15.4722 87 10.6681 84.9662 7.31893 81.484C3.96653 77.9984 2 72.986 2 66.904H1ZM21.2985 88V89H52.3369V88V87H21.2985V88ZM52.3369 88V89C58.6469 89 63.9836 86.7859 67.7409 82.8695C71.4946 78.9568 73.5996 73.4214 73.5996 66.904H72.5996H71.5996C71.5996 72.9872 69.6412 77.9998 66.2977 81.4849C62.9577 84.9663 58.163 87 52.3369 87V88ZM72.5996 66.904H73.5996V37.7409H72.5996H71.5996V66.904H72.5996ZM72.5996 37.7409H73.5996C73.5996 31.2065 71.4951 25.6622 67.7413 21.7447C63.9839 17.8234 58.647 15.6093 52.3369 15.6093V16.6093V17.6093C58.1629 17.6093 62.9574 19.6429 66.2972 23.1284C69.6408 26.6177 71.5996 31.6392 71.5996 37.7409H72.5996Z"
                    fill="url(#paint1_linear_1355_3789)"
                    mask="url(#path-3-outside-1_1355_3789)"
                />
            </g>
            <foreignObject x="5.91992" y="25.7088" width="61.7539" height="53.1895">
                <div
                    xmlns="http://www.w3.org/1999/xhtml"
                    style={{
                        backdropFilter: 'blur(7.5px)',
                        clipPath: 'url(#bgblur_1_1355_3789_clip_path)',
                        height: '100%',
                        width: '100%',
                    }}></div>
            </foreignObject>
            <g filter="url(#filter2_d_1355_3789)" data-figma-bg-blur-radius="15">
                <mask id="path-5-inside-2_1355_3789" fill="white">
                    <path d="M32.5495 63.8983C31.7476 63.8983 30.9457 63.5949 30.3335 62.9845L21.8382 54.514C20.6138 53.2932 20.6138 51.3156 21.8382 50.0984C23.0625 48.8777 25.0423 48.8741 26.2666 50.0949L32.5495 56.3594L47.3276 41.6244C48.552 40.4036 50.5317 40.4036 51.7561 41.6244C52.9804 42.8451 52.9804 44.8227 51.7561 46.0434L34.7655 62.9845C34.1533 63.5949 33.3514 63.8983 32.5495 63.8983Z" />
                </mask>
                <path
                    d="M32.5495 63.8983C31.7476 63.8983 30.9457 63.5949 30.3335 62.9845L21.8382 54.514C20.6138 53.2932 20.6138 51.3156 21.8382 50.0984C23.0625 48.8777 25.0423 48.8741 26.2666 50.0949L32.5495 56.3594L47.3276 41.6244C48.552 40.4036 50.5317 40.4036 51.7561 41.6244C52.9804 42.8451 52.9804 44.8227 51.7561 46.0434L34.7655 62.9845C34.1533 63.5949 33.3514 63.8983 32.5495 63.8983Z"
                    fill="url(#paint2_linear_1355_3789)"
                />
                <path
                    d="M21.8382 50.0984L21.9792 50.2403L21.9794 50.2401L21.8382 50.0984ZM32.5495 56.3594L32.4083 56.501L32.5495 56.6418L32.6907 56.501L32.5495 56.3594ZM51.7561 46.0434L51.6149 45.9018L51.7561 46.0434ZM34.7655 62.9845L34.9067 63.1261L34.7655 62.9845ZM32.5495 63.8983V63.6983C31.798 63.6983 31.0476 63.4141 30.4747 62.8428L30.3335 62.9845L30.1923 63.1261C30.8437 63.7756 31.6971 64.0983 32.5495 64.0983V63.8983ZM30.3335 62.9845L30.4747 62.8428L21.9794 54.3723L21.8382 54.514L21.697 54.6556L30.1923 63.1261L30.3335 62.9845ZM21.8382 54.514L21.9794 54.3723C20.8333 53.2296 20.8336 51.3792 21.9792 50.2403L21.8382 50.0984L21.6972 49.9566C20.3941 51.2521 20.3944 53.3568 21.697 54.6556L21.8382 54.514ZM21.8382 50.0984L21.9794 50.2401C23.126 49.0968 24.9794 49.0938 26.1254 50.2365L26.2666 50.0949L26.4078 49.9532C25.1051 48.6543 22.9991 48.6585 21.697 49.9568L21.8382 50.0984ZM26.2666 50.0949L26.1254 50.2365L32.4083 56.501L32.5495 56.3594L32.6907 56.2178L26.4078 49.9532L26.2666 50.0949ZM32.5495 56.3594L32.6907 56.501L47.4688 41.766L47.3276 41.6244L47.1864 41.4827L32.4083 56.2178L32.5495 56.3594ZM47.3276 41.6244L47.4688 41.766C48.6151 40.623 50.4686 40.623 51.6149 41.766L51.7561 41.6244L51.8973 41.4827C50.5949 40.1841 48.4888 40.1841 47.1864 41.4827L47.3276 41.6244ZM51.7561 41.6244L51.6149 41.766C52.7608 42.9086 52.7608 44.7592 51.6149 45.9018L51.7561 46.0434L51.8973 46.1851C53.2 44.8861 53.2 42.7817 51.8973 41.4827L51.7561 41.6244ZM51.7561 46.0434L51.6149 45.9018L34.6243 62.8428L34.7655 62.9845L34.9067 63.1261L51.8973 46.1851L51.7561 46.0434ZM34.7655 62.9845L34.6243 62.8428C34.0513 63.4141 33.301 63.6983 32.5495 63.6983V63.8983V64.0983C33.4018 64.0983 34.2553 63.7756 34.9067 63.1261L34.7655 62.9845Z"
                    fill="url(#paint3_linear_1355_3789)"
                    fillOpacity="0.5"
                    mask="url(#path-5-inside-2_1355_3789)"
                />
            </g>
            <defs>
                <filter
                    id="filter0_f_1355_3789"
                    x="23.1348"
                    y="-0.000854492"
                    width="71.5293"
                    height="74.4059"
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB">
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="BackgroundImageFix"
                        result="shape"
                    />
                    <feGaussianBlur stdDeviation="7" result="effect1_foregroundBlur_1355_3789" />
                </filter>
                <clipPath id="bgblur_0_1355_3789_clip_path" transform="translate(24 8.39072)">
                    <path d="M52.3369 16.6093H21.2985C9.16235 16.6093 1 25.1048 1 37.7409V66.904C1 79.5045 9.16235 88 21.2985 88H52.3369C64.473 88 72.5996 79.5045 72.5996 66.904V37.7409C72.5996 25.1048 64.473 16.6093 52.3369 16.6093Z" />
                </clipPath>
                <filter
                    id="filter2_d_1355_3789"
                    x="5.91992"
                    y="25.7088"
                    width="61.7539"
                    height="53.1895"
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB">
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                    />
                    <feOffset dx="5" dy="5" />
                    <feGaussianBlur stdDeviation="5" />
                    <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0.454902 0 0 0 0 0.870588 0 0 0 0 0.376471 0 0 0 0.5 0"
                    />
                    <feBlend
                        mode="normal"
                        in2="BackgroundImageFix"
                        result="effect1_dropShadow_1355_3789"
                    />
                    <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="effect1_dropShadow_1355_3789"
                        result="shape"
                    />
                </filter>
                <clipPath
                    id="bgblur_1_1355_3789_clip_path"
                    transform="translate(-5.91992 -25.7088)">
                    <path d="M32.5495 63.8983C31.7476 63.8983 30.9457 63.5949 30.3335 62.9845L21.8382 54.514C20.6138 53.2932 20.6138 51.3156 21.8382 50.0984C23.0625 48.8777 25.0423 48.8741 26.2666 50.0949L32.5495 56.3594L47.3276 41.6244C48.552 40.4036 50.5317 40.4036 51.7561 41.6244C52.9804 42.8451 52.9804 44.8227 51.7561 46.0434L34.7655 62.9845C34.1533 63.5949 33.3514 63.8983 32.5495 63.8983Z" />
                </clipPath>
                <linearGradient
                    id="paint0_linear_1355_3789"
                    x1="94.0009"
                    y1="14.4534"
                    x2="39.1564"
                    y2="48.118"
                    gradientUnits="userSpaceOnUse">
                    <stop stopColor="#39B93A" />
                    <stop offset="1" stopColor="#0B8F0C" />
                </linearGradient>
                <linearGradient
                    id="paint1_linear_1355_3789"
                    x1="12.3975"
                    y1="24.9264"
                    x2="57.909"
                    y2="81.4584"
                    gradientUnits="userSpaceOnUse">
                    <stop stopColor="white" stopOpacity="0.25" />
                    <stop offset="1" stopColor="white" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                    id="paint2_linear_1355_3789"
                    x1="50.423"
                    y1="44.8963"
                    x2="15.0844"
                    y2="46.4741"
                    gradientUnits="userSpaceOnUse">
                    <stop stopColor="white" />
                    <stop offset="1" stopColor="white" stopOpacity="0.2" />
                </linearGradient>
                <linearGradient
                    id="paint3_linear_1355_3789"
                    x1="24.3406"
                    y1="48.4877"
                    x2="51.3037"
                    y2="48.6915"
                    gradientUnits="userSpaceOnUse">
                    <stop stopColor="white" />
                    <stop offset="1" stopColor="white" stopOpacity="0" />
                </linearGradient>
            </defs>
        </svg>
    ),
};
